/**
 * terms_content.js - 약관 내용 및 기능 (so_c2033 전용)
 */

// 약관 제목 매핑
const TERMS_TITLES = {
    "01": "대부거래 표준약관",
    "02": "(근)질권설정 계약서",
    "03": "(근)질권설정 승낙 의뢰서",
    "04": "임의처분 및 금융거래정보제공 동의",
    "05": "자동계좌이체약관",
    "06": "전자금융거래 표준약관",
    "07": "여신거래 약정서",
    "08": "여신(기한연장) 신청서"
};

// 약관 내용 데이터
const TERMS_CONTENT = {
    // 1번: 대부거래 표준약관
    "01": `
        <div class="terms-body">
            <h1>대부거래 표준약관</h1>
            <div class="header-info">
                <p>표준약관 제10036호 (2019. 5. 15. 개정)</p>
                <p>대부업자: 빌리언대부</p>
            </div>
            <p>이 대부거래 표준약관(이하 "약관"이라 한다.)은 빌리언대부(이하 "대부업자"이라 한다)와 채무자와의 상호신뢰를 바탕으로 대부거래의 원활하고 공정한 처리를 위하여 만들어진 것이다.</p>
            <p>대부업자는 이 약관을 모든 영업점 및 전자매체에 비치·게시하고 채무자는 영업시간중 언제든지 열람하거나 그 교부를 청구할 수 있다.</p>

            <h3>제1조(목적)</h3>
            <p>이 약관은 대부업자와 채무자간의 대부거래에 있어서 권리와 의무를 명확히 하고 공정하며 건전한 금전소비대차를 하는 것을 목적으로 한다.</p>

            <h3>제2조(적용범위)</h3>
            <p>이 약관은 대부업자와 채무자 사이의 가계 또는 기업의 자금대부 또는 그 중개 및 어음할인 등의 금전의 대부와 관련된 대부업자와 채무자 사이의 모든 거래에 적용된다.</p>

            <h3>제3조(용어의 정의)</h3>
            <p>이 약관에서 사용하는 용어의 정의는 다음과 같다.</p>
            <ol>
                <li>"대부업"이라 함은 금전의 대부 또는 그 중개, 금전의 대부와 관련한 어음의 할인 및 이와 유사한 방법에 의한 금전의 교부와 관련된 사항을 그 업으로 행하는 사업을 말한다.</li>
                <li>"대부업자"라 함은 관할관청에 등록여부를 불문하고 대부업을 영위하는 개인 및 법인으로 한다.</li>
                <li>"채무자"라 함은 대부계약의 체결로 인하여 대부업자에 대하여 채무를 부담하는 자를 말한다.</li>
                <li>"보증인"이라 함은 채무자가 채무를 이행하지 않는 경우에 그 채무를 대신 이행할 종(從)된 채무를 부담하는 자를 말한다.</li>
            </ol>

            <h3>제4조(실명거래)</h3>
            <p>① 대부업자와 채무자 사이의 거래는 실명으로 한다.</p>
            <p>② 대부업자는 채무자가 본인임을 확인할 의무가 있다.</p>
            <p>③ 대부업자와 채무자 사이의 계약은 채무자 본인이 직접 체결하는 것을 원칙으로 하되, 채무자의 대리인과 계약을 체결하는 경우에는 채무자가 발급받은 인감증명서 또는 본인서명사실확인서(또는 전자본인서명사실확인서 발급증)를 첨부한 위임장에 의하여야 한다.</p>

            <h3>제5조(약관의 명시․설명․교부)</h3>
            <p>① 대부업자는 이 약관을 영업장에 비치하고, 채무자는 영업시간 중 언제든지 이를 열람하거나 그 교부를 청구할 수 있다.</p>
            <p>② 대부업자는 계약체결 전에 이 약관 제7조를 포함한 중요내용을 채무자가 이해할 수 있도록 설명하고 약관을 교부한다.</p>

            <h3>제6조(계약의 성립)</h3>
            <p>대부업자가 약관의 내용을 설명하고 채무자가 본 계약서에 의하여 이의 적용을 동의한 경우 계약은 성립한다.</p>

            <h3>제7조(계약서 필수기재사항)</h3>
            <p>대부거래 표준계약서에는 다음의 사항을 반드시 기재한다.</p>
            <ol>
                <li>대부업자(그 영업소를 포함한다)의 성명 또는 상호, 주소, 전화번호, 생년월일(성별) 또는 사업자등록번호</li>
                <li>대부업등록번호</li>
                <li>채무자의 성명 또는 상호, 주소, 전화번호, 생년월일(성별) 또는 사업자등록번호</li>
                <li>계약일자</li>
                <li>대부금액</li>
                <li>이자율(이자율의 세부내역 및 연이자율로 환산한 것을 포함)</li>
                <li>연체이자율</li>
                <li>변제기간 및 변제방법</li>
                <li>대부금을 변제받을 은행계좌번호</li>
                <li>채무의 조기상환조건</li>
                <li>부대비용이 있는 경우 그 내용 및 금액</li>
                <li>보증인이 있는 경우 보증인의 성명 또는 상호, 주소, 생년월일(성별) 또는 사업자등록번호, 보증의 내용</li>
            </ol>

            <h3>제8조(이자율 등의 제한)</h3>
            <p>① 대부업자는 관계법령이 정하는 이자율(연체이자율 포함)의 범위 내에서 계약을 체결하기로 한다.</p>
            <p>② 제1항의 규정에 의한 이자율을 산정함에 있어 사례금, 할인금, 수수료, 공제금, 연체이자, 체당금, 그밖에 그 명칭에 불구하고 대부와 관련하여 대부업자가 받는 것은 이를 이자로 본다.</p>
            <span class="indent">다만 당해 거래의 계약체결과 변제에 관한 부대비용으로서 관련 법령이 정한 사항은 그러하지 아니하다.</span>
            <p>③ 대부업자가 제1항의 규정에 의하지 않은 대부계약을 체결한 경우 제1항에 따른 이자율을 초과하는 부분에 대한 이자계약은 무효로 한다.</p>
            <p>④ 채무자가 대부업자에게 제1항에 따른 이자율을 초과하는 이자를 지급한 경우 그 초과 지급된 이자 상당금액은 원본에 충당되고, 원본에 충당되고 남은 금액이 있으면 그 반환을 청구할 수 있다.</p>
            <p>⑤ 대부업자가 선이자를 사전에 공제하는 경우에는 그 공제액을 제외하고 채무자가 실제로 받은 금액을 원본으로 하여 제1항에 따른 이자율을 산정한다.</p>

            <h3>제9조(비용의 부담)</h3>
            <p>① 다음 각 호의 비용은 채무자가 부담한다.</p>
            <ol>
                <li>채무자ㆍ보증인에 대한 대부업자의 채권ㆍ담보권 등의 권리의 행사ㆍ보전(해지 포함)에 관한 비용</li>
                <li>채무이행 지체에 따른 독촉 및 통지비용</li>
                <li>채무 및 보증채무와 관련된 증명서의 발급 비용</li>
            </ol>
            <p>② 대부업자나 대부업자가 지정하는 자가 제1항 각 호의 업무를 처리하고 그 비용을 채무자에게 청구하는 경우에는 실비를 초과할 수 없으며 소요비용이 최소화되도록 하여야 한다.</p>
            <p>③ 제1항에 의한 비용을 대부업자가 대신 지급한 경우에는, 대부업자는 이를 즉시 채무자에게 통지하여 채무자가 이를 곧 변제하도록 하고 만일 채무자가 그러하지 아니하는 경우에는 대부업자가 대신 지급한 금액에 대하여, 대신 지급한 날부터 다 갚는 날까지의 날짜수 만큼, 상법 제54조(상사법정이율)에 의한 연 6푼의 범위 내에서 약정금리로, 1년을 365일로 보고 1일 단위로 계산한 금액을 더하여 갚기로 한다.</p>
            <p>④ 대부업자는 대부계약 약정 시 채무자가 사전에 알 수 있도록, 약정이자 외에 담보대출에 소요되는 부대비용의 항목과 금액을 알려주어야 한다.</p>

            <h3>제10조(계약서의 교부 등)</h3>
            <p>① 계약내용을 명확히 하기 위하여 계약서는 2부를 작성하여 대부업자와 채무자가 각각 보관하는 것으로 한다.</p>
            <p>② 상환 완료 후 채무자는 대부계약서 및 계약관계서류의 반환을 서면으로 요구할 수 있고, 이의 반환 요청이 있는 경우 대부업자는 대부계약서 및 계약관계서류를 즉시 반환하기로 한다.</p>
            <p>③ 인터넷을 통해 전자적인 형태로 대부거래 약정을 체결하는 경우 대부업자는 지체없이 계약서를 전자우편 등으로 채무자에게 송부하고, 계약기간 동안 홈페이지에서 당해 계약사항의 열람, 인쇄가 가능하도록 조치하여야 한다.</p>
            <span class="indent">다만, 채무자의 요청이 있는 경우에는 계약서를 서면으로 교부한다.</span>

            <h3>제11조(담보의 제공)</h3>
            <p>채무자 또는 보증인의 신용악화, 제공한 담보의 가치감소의 사유가 발생하여 대부업자가 채권보전상 필요하다고 인정되는 경우에는 채무자는 대부업자의 청구에 의하여 대부업자가 인정하는 담보를 제공하거나 보증인을 세우기로 한다.</p>
            <span class="indent">다만, 담보의 제공이나 보증인을 세울 때에는 반드시 채권보전의 범위 내 이어야 한다.</span>

            <h3>제12조(기한의 이익의 상실)</h3>
            <p>① 채무자에게 다음 각 호의 사유가 발생한 경우에는 대부업자로부터의 독촉ㆍ통지 등이 없어도, 채무자는 기한의 이익을 상실한다.</p>
            <ol>
                <li>채무자가 제공한 담보재산에 대하여 압류명령이나 체납처분 압류 통지가 발송된 때 또는 기타의 방법에 의한 강제집행개시나 체납처분착수가 있는 때</li>
                <li>채무불이행자명부 등재 신청이 있는 때</li>
                <li>어음교환소의 거래정지처분이 있을 때</li>
                <li>도피 또는 기타의 사유로 금융기관에서 채무자에 대한 지급을 정지한 것으로 인정된 때</li>
                <li>파산신청이 있는 때</li>
            </ol>
            <p>② 채무자에게 다음 각 호의 사유가 발생한 경우에는 기한의 이익을 상실한다.</p>
            <span class="indent">다만, 대부업자는 기한의 이익상실일 7영업일전까지 다음 각 호의 채무이행지체사실과 이에 따라 기한의 이익이 상실된다는 사실을 채무자에게 통지하여야 하며, 기한의 이익상실일 7영업일전까지 통지하지 않은 경우에는 채무자는 실제통지가 도달한 날부터 7영업일이 경과한 날에 기한의 이익을 상실한다.</span>
            <ol>
                <li>이자를 지급하여야 할 때부터 2개월간 지체한 때</li>
                <li>분할상환금 또는 분할상환원리금의 지급을 2회 이상 연속하여 지체하고 그 금액이 대출금의 10분의1을 초과하는 경우</li>
            </ol>
            <p>③ 채무자에 관하여 다음 각 호에서 정한 사유중 하나라도 발생하여 대부업자의 채권보전에 현저한 위험이 예상될 경우, 대부업자는 서면으로 당해 위험 및 신용의 회복 등을 독촉하고, 그 통지의 도달일부터 10영업일 이상으로 대부업자가 정한 기간이 경과하면, 채무자는 대부업자에 대한 당해 채무의 기한의 이익을 상실하여 곧 이를 갚아야 할 의무를 진다.</p>
            <ol>
                <li>채무자와 그의 보증인이 대출금을 수령한 후 당초 제출하기로 약속한 대부계약에 필요한 중요서류(대출계약서, 보증계약서 등)를 30일 이내에 제출하지 않을 때</li>
                <li>채무자가 채무의 상환을 거부하는 의사를 명시적으로 표시할 때</li>
                <li>채무자 및 보증인이 계약서의 주요한 내용을 허위로 기재하거나 제출한 증빙서류가 위변조된 것으로 확인된 때</li>
            </ol>
            <p>④ 제1항 내지 제3항에 의하여 채무자가 대부업자에 대한 채무의 기한의 이익을 상실한 경우라도, 대부업자의 명시적 의사표시가 있거나, 대부업자가 분할상환금ㆍ이자ㆍ지연배상금을 받는 등 정상적인 거래의 계속이 있는 때에는, 그 채무 또는 대부업자가 지정하는 채무의 기한의 이익은 그 때부터 부활되는 것으로 본다.</p>

            <h3>제13조(기한전의 임의 상환 등)</h3>
            <p>채무자는 약정한 상환기일이 도래하기 전이라도 미리 아무런 부담 없이 원금의 전부 또는 일부를 상환할 수 있다.</p>
            <span class="indent">그러나 대부계약 체결 시 채무자와 기한전의 임의 변제로 대부업자가 받을 손해에 대하여 미리 약정한 경우에 한하여 수수료 등을 채무자가 부담한다.</span>

            <h3>제14조(채무의 변제 등의 충당)</h3>
            <p>① 채무자의 채무변제시 채무 전액을 소멸시키기에 부족한 때에는 비용, 이자, 원금의 순서로 충당하기로 한다.</p>
            <span class="indent">그러나 대부업자는 채무자에게 불리하지 않은 범위 내에서 충당순서를 달리할 수 있으나 채무자에게 이러한 사실을 서면으로 통지하여야 한다.</span>
            <p>② 변제될 채무가 수개인 경우로서 채무전액이 변제되지 않을 경우 강제집행 또는 담보권 실행경매에 의한 회수금에 대하여는 민법 기타 법률이 정하는 바에 따른다.</p>
            <p>③ 변제될 채무가 수개인 경우로서 제2항에 해당되지 않는 임의의 상환금으로 채무자의 채무전액을 없애기에 부족한 때에는 채무자가 지정하는 순서에 따라 변제에 충당하기로 한다.</p>
            <span class="indent">이 경우, 채무자가 지정하는 순서에 따를 경우, 대부업자의 채권보전에 지장이 생길 염려가 있는 때에는 대부업자는 지체없이 이의를 표시하고, 물적담보나 보증의 유무, 그 경중이나 처분의 난이, 변제기의 장단 등을 고려하여 대부업자가 변제에 충당할 채무를 바꾸어 지정할 수 있으나 채무자에게 이러한 사실을 서면으로 통지하여야 한다.</span>
            <p>④ 대부업자가 변제충당순서를 제3항에 따라 민법 기타 법률이 정하는바와 달리할 경우에는 대부업자의 채권보전에 지장이 없는 범위 내에서 채무자와 담보제공자 및 보증인의 정당한 이익을 고려하여야 한다.</p>

            <h3>제15조(영수증 등 서면교부)</h3>
            <p>대부업자는 채무자로부터 이자, 원금 등을 수령한 경우에는 영수증 및 대출잔액 확인서를 서면 또는 전자우편 등으로 교부하여야 한다.</p>

            <h3>제16조(통지사항 및 효력)</h3>
            <p>① 채무자는 주소, 전화번호, 근무처가 변경된(휴․퇴직 또는 해고되거나 전․폐업한 경우포함) 경우 서면으로 대부업자에게 곧 통지하여야 한다.</p>
            <p>② 채무자가 제1항에 의한 통지를 게을리 하여 대부업자가 발송한 서면통지 또는 기타서류가 채무자에게 연착하거나 도달되지 않은 때에는 보통의 우송기간이 경과한 때에 도달한 것으로 본다.</p>
            <span class="indent">이 경우 상계통지나 기한전의 채무변제 청구 등 중요한 의사표시는 반드시 배달증명부 내용증명에 의하여야 하며, 배달증명부 내용증명이 아닌 경우에는 도달한 것으로 보지 않고 다만 추정한다.</span>
            <p>③ 대부업자는 주소 및 전화번호가 변경된 경우 이를 채무자에게 서면으로 통지하여야 한다.</p>

            <h3>제17조(채권양도)</h3>
            <p>대부업자는 본 계약서상의 채권을 제3자에게 양도할 수는 있으나, 채권양도에 관하여는 반드시 사전에 채무자 및 보증인에게 동의를 얻어야 한다.</p>

            <h3>제18조(신용정보)</h3>
            <p>① 채무자가 제공한 신용정보(성명, 생년월일, 주소 등 본인의 특정정보 및 차입내용, 상환사항, 연체 등의 객관적 정보)는 이 계약에 의한 법적인 권리행사를 위해서만 이용할 수 있다.</p>
            <p>② 채무자 및 보증인은 그 주소지의 확인을 위하여 대부업자의 채권보전 등의 목적에 따라 개인별 주민등록표의 열람을 승낙하기로 한다.</p>
            <p>③ 대부업자는 채무자 본인과 보증인에 대하여만 개인정보를 요구할 수 있다.</p>

            <h3>제19조(이행장소ㆍ준거법)</h3>
            <p>① 채무의 이행장소는 다른 약정이 없는 한 거래 영업점으로 하고, 송금방법은 대부업자의 은행계좌에 입금하는 것을 원칙으로 한다.</p>
            <span class="indent">다만, 부실채권의 관리 등 상당한 사유로 채권관리업무를 대부업자의 본점ㆍ지역본부 또는 다른 영업점으로 이관한 경우에는, 이관 받은 본점ㆍ지역본부 또는 다른 영업점을 그 이행장소로 한다.</span>
            <p>② 채무자가 내국인이 아닌 경우라도, 이 약관에 의한 대부거래에 관하여 적용될 법률은 국내법을 적용한다.</p>

            <h3>제20조(불법적 채권추심 행위의 금지)</h3>
            <p>① 대부업자(대부업자로부터 대부계약에 따른 채권을 양도 받거나 채권의 추심을 위탁받은 자를 포함한다)는 대부거래 계약에 따른 채권을 추심함에 있어서 다음 각 호의 방법을 사용하지 않기로 한다.</p>
            <ol>
                <li>채무자 또는 관계인을 폭행․협박․체포 또는 감금하거나 그에게 위계나 위력을 사용하는 행위</li>
                <li>정당한 사유없이 반복적으로 또는 야간(오후 9시 이후부터 다음날 오전 8시까지를 말한다)에 채무자나 관계인을 방문함으로써 공포심이나 불안감을 유발하여 사생활 또는 업무의 평온을 심하게 해치는 행위</li>
                <li>정당한 사유없이 반복적으로 또는 야간에 전화하는 등 말․글․음향․영상 또는 물건을 채무자나 관계인에게 도달하게 함으로써 공포심이나 불안감을 유발하여 사생활 또는 업무의 평온을 심하게 해치는 행위</li>
                <li>채무자 외의 사람(보증인을 포함한다)에게 채무에 관한 거짓 사실을 알리는 행위</li>
                <li>채무자 또는 관계인에게 금전의 차용이나 그 밖의 이와 유사한 방법으로 채무의 변제자금을 마련할 것을 강요함으로써 공포심이나 불안감을 유발하여 사생활 또는 업무의 평온을 심하게 해치는 행위</li>
                <li>채무를 변제할 법률상 의무가 없는 채무자 외의 사람에게 채무자를 대신하여 채무를 변제할 것을 반복적으로 요구함으로써 공포심이나 불안감을 유발하여 사생활 또는 업무의 평온을 심하게 해치는 행위</li>
                <li>엽서에 의한 채무변제요구 등 채무자 외의 자가 채무사실을 알 수 있게 하는 행위</li>
                <li>채무자의 연락두절 등 소재파악이 곤란한 경우가 아님에도 채무자의 관계인에게 채무자의 소재, 연락처 또는 소재를 알 수 있는 방법 등을 문의하는 행위</li>
            </ol>
            <p>② 대부업자는 기타 「채권의 공정한 추심에 관한 법률」에서 채권추심과 관련하여 금지하고 있는 행위를 하여서는 아니 된다.</p>

            <h3>제21조(담보물 처분 전 사전통지)</h3>
            <p>대부업자는 약정 대부기간이 만료되거나 계약이 종료된 이후 담보물을 처분하고자 하는 경우에는 채무자 또는 소유자에게 미리 그 사항을 통지하여야 한다.</p>
            <span class="indent">단, 법원의 경매절차가 개시되어 채무자 또는 소유자에게 별도의 통지가 이루어진 경우에는 이로 갈음할 수 있다.</span>

            <h3>제22조(약관의 변경)</h3>
            <p>① 대부업자가 이 약관을 변경하고자 할 경우, 채무자에게 불리한 내용이 될 때에는 서면통지의 방법으로 이를 알리고, 채무자에게 불리한 내용이 아닌 경우에는 거래영업점에 게시함으로써 이를 알려야 한다.</p>
            <span class="indent">그러나 서면통지나 게시의 경우에는 반드시 제2항의 뜻을 명시하여야 한다.</span>
            <p>② 통지가 도달한 때 또는 게시한 때부터 1개월 이내에 채무자의 서면에 의한 이의가 대부업자에게 도달하지 않은 때에는, 약관의 변경을 승인한 것으로 본다.</p>

            <h3>제23조(규정의 준용)</h3>
            <p>이 약관에서 정하지 아니한 사항에 관하여는 「대부업 등의 등록 및 금융이용자 보호에 관한 법률」 및 동법 시행령 등 관계 법령에 따른다.</p>

            <h3>제24조(관할법원의 합의)</h3>
            <p>이 약관에 의한 대부거래 계약에 관하여 대부업자와 채무자 사이에 소송의 필요가 생긴 때에는 법이 정하는 관할법원과 아울러 대부업자의 거래영업점 소재지 지방법원을 관할법원으로 하기로 한다.</p>
            <span class="indent">다만, 채무자의 책임있는 사유로 부실채권이 발생되어 그 채권의 관리를 위하여 대부업자가 본점, 지역본부 또는 다른 영업점으로 그 채권관리업무를 이관한 경우에는 법이 정하는 관할법원과 아울러 이관 받은 본점, 지역본부 또는 다른 영업점 소재지 지방법원을 관할법원으로 하기로 한다.</span>
        </div>
    `,

    // 2번: (근)질권설정 계약서
    "02": `
        <div class="terms-body">
            <h1>(근)질권설정 계약서</h1>

            <div class="warning-box">
                담보의 제공은 재산상 손실을 가져올 수도 있는 중요한 법률행위이므로, 하단의 「담보제공자가 꼭 알아두어야 할 사항」과 계약서의 내용을 충분히 읽은 후 신중하게 판단하시기 바랍니다.<br>
                본 (근)질권설정 계약은, 설정자 본인의 공인인증 확인을 거쳐 온라인으로 체결됩니다.
            </div>

            <div class="header-info">
                <p><strong>빌리언대부 주식회사 앞</strong></p>
                <p><span class="terms-input-field date-field">20&nbsp;&nbsp;&nbsp;&nbsp;년&nbsp;&nbsp;&nbsp;&nbsp;월&nbsp;&nbsp;&nbsp;&nbsp;일</span></p>
                <p>(근)질권설정자(채무자) : <span class="terms-input-field name-field" style="text-align: right; padding-right: 30px;">(인)</span></p>
                <p>주소 : <span class="terms-input-field address-field">&nbsp;</span></p>
            </div>

            <h3>제1조 ((근)질권의 설정)</h3>
            <p>(근)질권설정자(채무자, 이하 "설정자"라 한다)는 채권자인 빌리언대부 주식회사(질권자, 이하 "대부업자"라 한다)으로부터 주식매입자금대출을 받음에 있어, 대부거래 표준약관 및 계좌운용규칙을 승인하고, 이 계약서 하단의 (근)질권 목적물에 대하여 다음의 내용으로 (근)질권을 설정할 것을 승낙한다.</p>

            <ol>
                <li>
                    <strong>피담보채무의 범위</strong><br>
                    설정자는 다음의 "한정근담보"에서 정한 채무(이자, 지연배상금, 기타 부대채무를 포함한다)를 담보하기로 한다.
                    <div class="indent">
                        <strong>[한정근담보]</strong><br>
                        채무자가 채권자(본·지점)에 대하여 다음 종류의 거래로 말미암아 현재 및 장래에 부담하는 모든 채무<br>
                        – 빌리언대부 주식회사 주식매입자금대출 거래
                    </div>
                </li>
                <li>
                    <strong>채권최고액</strong><br>
                    본 (근)질권약정으로 인해 발생하는 <strong>최초 대출원금의 130%</strong>를 채권최고액으로 한다.<br>
                    (※ 채권최고액의 구체적인 금액은 온라인 대출상품임을 고려하여, 주식매입자금대출 신청 홈페이지에서 별도 안내한다.)
                </li>
                <li>
                    <strong>(근)질권 결산기</strong><br>
                    설정자는 다음의 "장래지정형"에 따라 근질권의 결산기를 정한다.
                    <div class="indent">
                        <strong>[장래지정형]</strong><br>
                        결산기를 미리 정하지 아니한다. 이 경우 계약일부터 3년이 경과하면, 본인은 서면 통지에 의하여 근질권 결산기를 지정할 수 있으며, 그 결산기는 통지 도달일로부터 14일 이후가 되어야 한다.<br>
                        이 기간에 미달하는 때에는, 통지 도달일부터 14일이 되는 날을 결산기로 본다.
                    </div>
                </li>
                <li>
                    <strong>(근)질권의 목적물</strong>
                    <table>
                        <tr>
                            <th>종별</th>
                            <th>내 용</th>
                        </tr>
                        <tr>
                            <td>증권위탁계좌</td>
                            <td style="line-height: 2.5;">
                                증권사 : <span class="terms-input-field" style="width: 200px;">&nbsp;</span><br>
                                명의인 : <span class="terms-input-field" style="width: 200px;">&nbsp;</span><br>
                                증권계좌번호 : <span class="terms-input-field" style="width: 230px;">&nbsp;</span>
                            </td>
                        </tr>
                        <tr>
                            <td>금액 또는<br>(근)질권 목적물 범위</td>
                            <td>대출시점의 계좌 내 보유하고 있는 자산(예탁금 및 유가증권) 및 대출시점 이후 자산변동으로 인한 증감분</td>
                        </tr>
                    </table>
                </li>
            </ol>

            <h3>제2조 ((근)질권의 효력)</h3>
            <p>본 질권의 목적물은 설정자 명의 증권위탁계좌 내의 예탁금 및 예탁유가증권에 대한 반환청구권이며, 질권 설정 이후 입금고 및 매매거래에 의하여 증감하는 예탁금 및 예탁유가증권에 대한 반환청구권을 모두 포함한다.</p>
            <p>설정자는 대부업자의 동의가 있는 경우를 제외하고는 (근)질권 목적물 계좌의 예탁금 및 예탁유가증권에 대하여 출금 및 출고를 할 수 없다. 다만, 설정자 본인의 주식거래(매매)는 설정자가 동의한 계좌운용규칙 범위 내에서 자유로우며, 채권최고액을 초과하는 예탁금에 대하여는 인출이 가능하다.</p>
            <p>제3자가 가압류 또는 압류하는 등 본 계좌에 대하여 권리를 주장하는 경우, 제3자의 권리를 보호하기 위하여 (근)질권 목적물 계좌에 대한 모든 주식매매거래가 중지되며, 이때 피담보채무는 확정된다.</p>

            <h3>제3조 ((근)질권의 실행)</h3>
            <p>설정자의 피담보채무의 기한 도래, 기한의 이익 상실 또는 설정자가 동의한 계좌운용규칙에 따른 로스컷 사유(최소담보비율 하락 등)로 인하여 채무의 이행의무가 발생한 때, 대부업자는 채권최고액 범위 내에서 (근)질권을 실행할 수 있다. 이 경우 대부업자는 (근)질권 목적물 계좌 내 유가증권에 대한 자동 반대매매(시장가 처분)를 통하여 환가한 대금과 예탁금으로 피담보채무를 회수할 수 있다.</p>
            <p>대부업자가 적법한 절차에 의하여 (근)질권 실행을 의뢰하는 경우, 제3자에 의한 압류나 가압류에도 불구하고 질권실행을 할 수 있다. 다만, 제3자에 의한 압류 또는 가압류가 본 질권에 우선하는 경우 등 관련 법령에 의하여 질권실행이 제한되는 경우에는 그러하지 아니한다.</p>
            <p>대부업자는 설정자가 동의한 「계좌운용규칙 동의서」에 따라, (근)질권 설정된 증권위탁계좌 내 설정자의 주식거래(매매)에 대하여 제한(매수불가, 보유불가, 로스컷 및 오버나잇 규정에 의한 자동반대매매 규정, 담보비율의 제한 등)을 할 수 있다.</p>

            <h3>제4조 (담보 등의 변경·해지·해제)</h3>
            <p>설정자가 동의한 때나, 동등한 가치 이상의 담보대체, 동등한 자력 이상의 보증인 교체, 또는 일부 변제액에 비례한 담보나 보증의 해지·해제 등으로서 설정자가 대위변제할 경우의 구상실현에 영향이 없다고 판단될 때에는, 거래상 필요에 따라 대부업자는 다른 담보나 보증을 변경 또는 해지·해제할 수 있다.</p>

            <h3>제5조 (다른 약정과의 관계)</h3>
            <p>설정자(채무자)는 기 동의한 빌리언대부 주식회사 주식매입자금대출 계좌(담보)운용규칙을 충분히 이해하고 이에 동의한다.</p>
            <p>기 동의한 대출시점의 계좌운용규칙에 변경이 있는 경우, 대부업자가 설정자(채무자)에게 통지함으로써 그 효력이 발생하며, 그 통지 방법은 반드시 서면일 것을 요하지 아니한다.</p>
            <p>계좌운용규칙의 이후 변경에 대하여도, 대부업자가 설정자(채무자)에게 통지함으로써 효력이 발생하며, 이 경우 역시 통지 방법은 반드시 서면일 것을 요하지 아니한다.</p>

            <h3>제6조 (기타)</h3>
            <p>질권실행 등과 관련하여 제3채무자(증권회사)는 질권설정자에게 SMS로 그 내용을 통보할 수 있으며, 질권설정자는 이를 거부할 수 없다.</p>
            <p>(근)질권설정자가 본 계약서 내용에 동의할 경우, 질권자와 질권설정자의 요청에 의하여 제1조 제4항의 '(근)질권의 목적물'에 해당 증권사의 질권설정 승낙이 이루어진 것으로 본다.</p>
            <p>질권설정자는 질권자에게 질권설정 승낙 의뢰에 관한 권한을 위임한다.</p>

            <br><hr><br>

            <h3>※ 담보제공자(질권설정자)가 꼭 알아두어야 할 사항</h3>
            
            <p><strong>1. 질권이란?</strong></p>
            <p>채무자가 기일에 채무를 상환하지 않을 때, 채권자가 담보로 취득한 예·적금 등 지명채권을 직접 추심하거나, 유가증권·동산 등의 담보물을 처분하여 그 추심 또는 매각대금으로 우선적으로 변제받는 권리를 말한다.</p>
            <p>따라서 자기 소유의 예·적금이나 유가증권·동산 등에 타인을 위하여 질권을 설정하는 행위는, 타인의 채무불이행으로 인하여 자기 재산을 잃게 될 수 있는 위험을 부담하는 행위이다.</p>

            <p><strong>2. 담보종류에 따른 책임범위</strong></p>
            <p><strong>"특정채무담보"</strong></p>
            <span class="indent">채무자가 채권자에 대하여 부담하는 특정된 채무만을 담보하며, 그 채무가 연기·재취급 또는 다른 여신으로 대환된 때에는 담보하지 않는다.</span>

            <p><strong>"근담보"</strong></p>
            <span class="indent">채무자와 채권자 사이에 이미 맺어져 있거나 앞으로 맺게 될 거래계약으로부터 현재 또는 장래에 발생할 채무를 채권최고액의 범위 내에서 담보하는 것으로, 다음과 같은 유형이 있다.</span>

            <div class="indent">
                <p><strong>① "특정 근담보"</strong></p>
                <span class="indent">특정된 거래계약(예: ○년 ○월 ○일 여신거래약정서)으로부터 계속적으로 발생하는 채무를 담보하며, 그 채무가 기한 연기된 때에도 담보한다. 그러나 재취급 또는 다른 여신으로 대환된 때에는 담보하지 않는다.</span>

                <p><strong>② "한정 근담보"</strong></p>
                <span class="indent">특정한 종류의 거래(예: 할인어음 거래)에 대하여, 이미 맺어져 있거나 앞으로 맺게 될 거래계약으로부터 현재 및 장래에 발생하는 채무를 모두 담보한다. 그 채무의 연기나 재취급은 물론, 같은 종류의 여신으로 대환된 때에는 담보한다. 다만, 다른 종류의 여신으로 대환된 때에는 담보하지 않는다.</span>

                <p><strong>③ "포괄 근담보"</strong></p>
                <span class="indent">채무자가 채권자에게 부담하는 현재 및 장래의 모든 채무(대부거래로 인한 채무뿐만 아니라 기타 다른 형태의 채무를 포함한다)를 담보하는 것으로, 그 책임범위가 매우 광범위하다. 따라서 포괄근담보를 선택할 경우에는, 다시 한 번 신중하게 생각한 후에 결정하여야 한다.</span>
            </div>

            <p><strong>3. 담보제공자가 연대보증까지 서는 경우</strong></p>
            <span class="indent">담보제공자가 연대보증을 별도로 서는 경우, 채권자는 담보로 제공된 예·적금·부금·수익권·유가증권·동산 외에도 담보제공자의 다른 일반재산에 대하여도 집행을 할 수 있다.</span>
        </div>
    `,

    // 3번: (근)질권설정 승낙 의뢰서
    "03": `
        <div class="terms-body">
            <h1>(근)질권설정 승낙 의뢰서</h1>

            <p>본인은 빌리언대부 주식회사(이하 "질권자")에 대하여 부담하는 채무의 담보로, 아래와 같이 (근)질권을 설정하고자 하오니 승낙하여 주시기 바랍니다.</p>

            <h3>1. (근)질권 설정 내용</h3>
            <p><strong>질권 목적물 :</strong> 증권계좌 내 예치금 및 유가증권 일체</p>
            <p><strong>(근)질권 설정 금액(채권최고액) :</strong> 대출원금의 130%</p>

            <h3>2. 계좌 정보</h3>
            <table>
                <thead>
                    <tr>
                        <th>명의인(본인)</th>
                        <th>(근)질권설정 계좌번호</th>
                        <th>(근)질권설정 금액</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style="height: 50px; vertical-align: middle; text-align: center;"><span class="terms-input-field" style="width: 150px;">&nbsp;</span></td>
                        <td style="vertical-align: middle; text-align: center;"><span class="terms-input-field" style="width: 200px;">&nbsp;</span></td>
                        <td style="vertical-align: middle; text-align: right; padding-right: 20px;"><span class="terms-input-field" style="width: 180px; text-align: right; padding-right: 10px;">원</span></td>
                    </tr>
                </tbody>
            </table>

            <h3>3. 질권설정 관련 특별 확인사항</h3>
            <p>증권계좌 내 유가증권의 매매결과에 따라 계좌 평가금액이 (근)질권설정금액 이하로 감소할 수 있음을 인정합니다.</p>
            <p>위 계좌는 본인의 종합계좌번호로서, 상기 위탁계좌와 동일한 권리와 의무를 가지며 그 효력 또한 동일함을 확인합니다.</p>

            <br><hr><br>

            <div style="margin-top: 20px;">
                <p><strong>(근)질권설정자(본인)</strong></p>
                <p>주소 : <span class="terms-input-field" style="width: 400px;">&nbsp;</span></p>
                <p>주민등록번호(또는 운전면허번호) : <span class="terms-input-field" style="width: 300px;">&nbsp;</span></p>
                <p>성명(서명 또는 전자서명) : <span class="terms-input-field" style="width: 200px; text-align: right; padding-right: 30px;">(인)</span></p>
            </div>

            <div style="margin-top: 40px; margin-bottom: 40px;">
                <p><strong>(근)질권자</strong></p>
                <p>주소 : 빌리언대부 주식회사</p>
                <p>대표이사 : <span class="terms-input-field" style="width: 200px; text-align: right; padding-right: 30px;">(인)</span></p>
            </div>
        </div>
    `,

    // 4번: 임의처분 및 금융거래정보제공 동의서
    "04": `
        <div class="terms-body">
            <h1>임의처분 및 금융거래정보제공 동의서</h1>

            <div class="header-info">
                <p><strong>빌리언대부 주식회사 귀중</strong></p>
            </div>

            <p>본인(채무자 겸 담보제공자, 이하 "본인"이라 한다)은, 빌리언대부 주식회사(이하 "대부업자"라 한다)으로부터 대출을 받음에 있어, 다음 사항에 대하여 명확히 동의하고 승낙합니다.</p>

            <h3>제1조(담보증권 임의처분에 관한 동의)</h3>
            <p>본인은 대부업자가 요구하는 적정 담보가격 미달 또는 본인이 사전에 설정한 최저담보유지비율 미달 등으로 인해 담보비율이 하락한 경우, 다음에 동의합니다.</p>
            <ol>
                <li>대부업자는 본인의 담보 주식·유가증권을 임의로 처분(반대매매 포함)할 수 있으며, 그 환가대금은 본인의 채무 변제에 우선 충당할 수 있습니다.</li>
                <li>또는 대부업자는 시가 상당액으로 본인의 채무 전부 또는 일부를 대위변제 형식으로 상계 처리하기 위하여, 본인의 담보증권을 취득할 수 있습니다.</li>
                <li>본인은 위 처분 또는 취득행위에 대하여 민·형사상 어떠한 이의도 제기하지 않을 것을 확약합니다.</li>
            </ol>

            <h3>제2조(금융거래정보 제공 동의)</h3>
            <p>본인은 본인의 담보계좌와 관련하여 아래 금융거래정보를 대부업자에게 제공하는 것에 동의합니다.</p>
            <table>
                <colgroup>
                    <col style="width: 30%;">
                    <col style="width: 70%;">
                </colgroup>
                <tr>
                    <th>제공받는 자</th>
                    <td>빌리언대부 주식회사</td>
                </tr>
                <tr>
                    <th>제공되는 정보</th>
                    <td>
                        1. 대출 가능 여부 확인을 위한 계좌현황<br>
                        2. 담보비율 및 반대매매(임의처분) 현황<br>
                        3. 기타 대출심사 및 담보관리 목적상 필요한 범위의 금융거래정보
                    </td>
                </tr>
                <tr>
                    <th>제공 시기</th>
                    <td>
                        1. 본 동의서에 동의하는 시점<br>
                        2. 반대매매(임의처분) 실행 후 당일
                    </td>
                </tr>
                <tr>
                    <th>제공 방법</th>
                    <td>온라인(전산연동), 전화, 팩스, 전자우편 등<br>(필요 시 증권사 시스템을 통한 자동 제공 포함)</td>
                </tr>
            </table>

            <h3>제3조(금융실명거래·비밀보장 관련 통보 제외 신청)</h3>
            <p>본인은 「금융실명거래 및 비밀보장에 관한 법률」에 따른 정보제공사실 통보서의 제공을 대부업자가 생략하는 것에 동의하며, 이에 관하여 대부업자에게 어떠한 이의도 제기하지 않습니다.</p>

            <h3>제4조(책임 부담)</h3>
            <p>본인은 본 동의서와 관련하여 향후 발생하는 모든 손해 및 제반 분쟁에 대하여 본인이 전적으로 책임을 부담할 것을 확약합니다.</p>

            <br><hr><br>

            <div style="margin-top: 30px;">
                <p style="text-align: right;"><span class="terms-input-field date-field">20&nbsp;&nbsp;&nbsp;&nbsp;년&nbsp;&nbsp;&nbsp;&nbsp;월&nbsp;&nbsp;&nbsp;&nbsp;일</span></p>
                <br>
                <p><strong>본인(채무자 겸 담보제공자)</strong></p>
                <p>성명 : <span class="terms-input-field" style="width: 200px;">&nbsp;</span> (전자서명 또는 공동인증서)</p>
                <p>주민등록번호(또는 운전면허번호) : <span class="terms-input-field" style="width: 300px;">&nbsp;</span></p>
                <p>주소 : <span class="terms-input-field" style="width: 400px;">&nbsp;</span></p>
            </div>
        </div>
    `,

    // 5번: 자동계좌이체약관
    "05": `
        <div class="terms-body">
            <h1>자동계좌이체약관</h1>

            <h3>제1조(약관의 적용)</h3>
            <p>본 약관은 <strong>지로 자동계좌이체 제도(이하 "자동이체")</strong>를 이용하여 각종 대금을 납부하고자 하는 자(이하 "납부자")와, 납부자의 예금계좌를 보유한 <strong>빌리언대부 주식회사(이하 "대부업자")</strong>에 적용합니다.</p>

            <h3>제2조(영업일)</h3>
            <p>영업일은 다음 각 호의 휴일을 제외한 날로 합니다.</p>
            <ol>
                <li>「관공서의 공휴일에 관한 규정」에 따른 공휴일</li>
                <li>토요일</li>
                <li>근로자의 날</li>
            </ol>

            <h3>제3조(출금)</h3>
            <p>① 납부자가 지급하여야 할 요금에 대하여 이용기관(출금 의뢰기관)이 대부업자 앞으로 청구한 경우, 별도의 통지 없이 납부자의 지정계좌에서 <strong>납기일(휴일인 경우 다음 영업일)</strong>에 자동 출금하여 납부합니다.</p>
            <p>② 위 출금 절차는 대부업자의 예금약관이나 약정서의 규정에 불구하고, 예금청구서 등의 제출 없이 자동이체 처리절차로 출금할 수 있습니다.</p>

            <h3>제4조(과실책임)</h3>
            <p>자동이체 계좌의 잔액(자동대출 약정이 있는 경우 대출한도 포함)이 납기일 현재 이용기관의 청구금액보다 부족하거나, 예금의 지급제한, 약정대출 연체 등 납부자의 과실로 대체납부가 불가능한 경우 발생하는 손해는 납부자의 책임으로 합니다.</p>

            <h3>제5조(부분출금)</h3>
            <p>부분출금방식을 승인한 이용기관의 경우, 납부자의 예금잔액이 청구금액에 부족하더라도 잔액 전부를 출금할 수 있습니다.</p>

            <h3>제6조(출금 우선순위)</h3>
            <p>납기일에 동일한 종류의 자동이체 청구가 여러 건 있는 경우, 출금 우선순위는 대부업자가 정한 기준에 따릅니다.</p>

            <h3>제7조(최초 개시일)</h3>
            <p>자동이체 신규 신청에 따른 이체 개시일은 이용기관의 사정에 따라 결정되며, 이용기관이 사전 통지한 납기일을 최초 개시일로 합니다.</p>

            <h3>제8조(자동이체 신청 방식)</h3>
            <p>대부업자는 자동이체를 실행하기 위하여 다음 각 호 중 하나의 방식으로 납부자의 출금 동의를 얻어야 합니다.</p>
            <ol>
                <li>대부업자가 납부자로부터 직접 서면(공동인증서 등 전자서명이 있는 전자문서 포함)으로 자동이체 신청을 받는 방법</li>
                <li>이용기관이 납부자의 서면 출금 동의를 받아, 이를 대부업자에게 전달(전자적 방법으로 내역 전송 포함)하는 방법</li>
            </ol>

            <h3>제9조(신청서 제출기한)</h3>
            <p>제8조에 따른 자동이체 신청(신규, 변경, 해지)은 해당 납기일 30일 전까지 제출하여야 합니다. 해지 신청서를 제출한 경우, 이는 「전자금융거래법」에서 정하는 출금 동의의 철회로 봅니다.</p>

            <h3>제10조(출금 기준 및 이의제기)</h3>
            <p>① 자동이체 계좌에서의 출금은, 해당 납기일 대부업자 영업시간 내 입금된 예금에 한하여 이용기관의 청구대로 출금합니다.</p>
            <p>② 청구금액에 대한 이의가 있는 경우, 납부자와 이용기관이 협의하여 조정하여야 합니다.</p>

            <h3>제11조(정보제공)</h3>
            <p>자동이체 업무 처리를 위하여, 납부자의 다음 정보가 이용기관에 제공됩니다.</p>
            <ol>
                <li>거래 대부업자명</li>
                <li>지점명</li>
                <li>계좌번호</li>
                <li>주민등록번호 또는 사업자등록번호 등</li>
            </ol>
            <p>제공된 정보는 자동이체 업무 외의 목적에 사용할 수 없습니다.</p>

            <h3>제12조(대부업자의 자동이체 임의 해지)</h3>
            <p>자동이체 등록계좌가 2년 동안 자동이체 이용실적이 없는 경우, 대부업자는 해당 납부자에게 사전 통지 없이 자동이체를 해지할 수 있습니다.</p>

            <h3>제13조(이용기관에 신청한 경우의 약관 적용)</h3>
            <p>납부자가 제8조의 방법에 따라 이용기관에 직접 자동이체 신청서를 제출한 경우에도, 본 약관이 동일하게 적용됩니다.</p>

            <h3>제14조(약관의 변경)</h3>
            <p>① 대부업자가 본 약관을 변경하고자 할 경우, 변경 1개월 전부터 1개월간 본점·영업점 및 게시 가능한 전자적 장치를 통하여 게시하고, 또한 납부자가 제공한 전자우편으로 통지합니다.</p>
            <p>② 납부자는 통지일로부터 변경 약관의 시행일 전 영업일까지 전자금융거래 계약을 해지할 수 있으며, 동 기간 내 이의가 대부업자에 도달하지 않으면 승인한 것으로 봅니다.</p>

            <h3>제15조(다른 약관과의 관계)</h3>
            <p>① 자동이체 거래에는 본 약관 외에도 전자금융거래기본약관이 적용되며, 두 약관이 상충하는 경우 본 약관이 우선 적용됩니다.</p>
            <p>② 본 약관과 전자금융거래기본약관에 정하지 않은 사항은, 전자금융거래법 등 관계법령을 적용합니다.</p>
        </div>
    `,

    // 6번: 전자금융거래 표준약관
    "06": `
        <div class="terms-body">
            <h1>전자금융거래 표준약관</h1>

            <h3>제1조(목적)</h3>
            <p>이 약관은 빌리언대부 주식회사(이하 "대부업자"라 한다)와 이용자 사이의 전자금융거래에 관한 기본적인 사항을 정함으로써, 거래의 신속하고 효율적인 처리를 도모하고 거래당사자 상호간의 이해관계를 합리적으로 조정하는 것을 목적으로 한다.</p>

            <h3>제2조(용어의 정의)</h3>
            <p>① 이 약관에서 사용하는 용어의 정의는 다음과 같다.</p>
            <ol>
                <li>"전자금융거래"라 함은 대부업자가 전자적 장치를 통하여 제공하는 금융상품 및 서비스를 이용자가 전자적 장치를 통하여 비대면·자동화된 방식으로 직접 이용하는 거래를 말한다.</li>
                <li>"이용자"라 함은 전자금융거래를 위하여 대부업자와 체결한 계약(이하 "전자금융거래계약"이라 한다)에 따라 대부업자의 전자금융거래 서비스를 이용하는 고객을 말한다.</li>
                <li>"지급인"이라 함은 전자금융거래에 의하여 자금이 출금되는 계좌(이하 "출금계좌"라 한다)의 명의인을 말한다.</li>
                <li>"수취인"이라 함은 전자금융거래에 의하여 자금이 입금되는 계좌(이하 "입금계좌"라 한다)의 명의인을 말한다.</li>
                <li>"전자적 장치"라 함은 현금자동지급기, 자동입출금기, 지급용 단말기, 컴퓨터, 전화기, 모바일기기, 그 밖의 전자적 방법으로 전자금융거래정보를 전송하거나 처리하는 데 이용되는 장치를 말한다.</li>
                <li>"접근매체"라 함은 전자금융거래에 있어서 거래지시를 하거나 이용자 및 거래내용의 진정성을 확보하기 위하여 사용되는 다음 각 목의 어느 하나에 해당하는 수단 또는 정보를 말한다.
                    <div class="indent">가. 대부업자가 제공한 전자식 카드 및 이에 준하는 전자적 정보</div>
                    <div class="indent">나. 전자서명법에 따른 전자서명생성정보 또는 공동(공인)인증서</div>
                    <div class="indent">다. 대부업자에 등록된 이용자번호</div>
                    <div class="indent">라. 등록되어 있는 이용자의 생체정보</div>
                    <div class="indent">마. 가목 또는 나목의 수단이나 정보를 사용하는 데 필요한 비밀번호</div>
                </li>
                <li>"전자문서"라 함은 「전자금융거래법」 제2조 제1호의 규정에 따라 작성, 송·수신 또는 저장된 정보를 말한다.</li>
                <li>"거래지시"라 함은 이용자가 전자금융거래계약에 의하여 대부업자에 개별적인 전자금융거래의 처리를 지시하는 것을 말한다.</li>
                <li>"오류"라 함은 이용자의 고의 또는 과실 없이 전자금융거래가 약관(개별약관을 포함한다), 전자금융거래계약 또는 이용자의 거래지시에 따라 이행되지 아니한 경우를 말한다.</li>
                <li>"계좌이체"라 함은 지급인이 이용하는 전자적 장치를 통한 지급지시에 따라 대부업자가 지급인의 특정계좌에서 자금을 출금하여 대부업자 또는 다른 금융기관의 계좌에 입금하는 것을 말한다.</li>
                <li>"추심이체"라 함은 수취인이 이용하는 전자적 장치를 통한 추심지시에 따라 대부업자가 지급인의 특정계좌에서 자금을 인출하여 대부업자 또는 다른 금융기관의 계좌에 입금하는 것을 말한다.</li>
                <li>"예약에 의한 계좌이체"라 함은 계좌이체가 장래의 특정일자에 이루어지도록 이용자가 미리 거래지시하고, 대부업자가 이를 해당 일자에 처리하는 것을 말한다.</li>
                <li>"계좌송금"이라 함은 이용자가 현금자동지급기, 자동입출금기를 통하여 자기 또는 타인의 계좌에 자금을 입금하는 것을 말한다.</li>
                <li>"예약에 의한 추심이체"라 함은 추심이체가 장래의 특정일자에 이루어지도록 이용자가 미리 거래지시하고, 대부업자가 이를 해당 일자에 처리하는 것을 말한다.</li>
                <li>"영업일"이라 함은 통상 대부업자 영업점에서 정상적인 영업을 하는 날을 말한다.</li>
                <li>"전자금융보조업자"라 함은 대부업자로부터 전자금융거래 관련 일부 업무를 위탁받아 수행하는 자를 말한다.</li>
            </ol>
            <p>② 이 약관에서 별도로 정하지 아니한 용어는 「전자금융거래법」 및 관계 법령 등에서 정하는 바에 따른다.</p>

            <h3>제3조(적용되는 거래)</h3>
            <p>이 약관은 대부업자와 이용자 사이에 이루어지는 다음 각 호의 전자적 장치를 이용하여 이루어지는 계좌이체(예약에 의한 계좌이체를 포함한다), 추심이체(예약에 의한 추심이체를 포함한다), 계좌송금과 관련한 조회, 입·출금 등의 전자금융거래에 적용된다.</p>
            <ol>
                <li>현금자동지급기, 자동입출금기, 지급용단말기에 의한 거래</li>
                <li>컴퓨터(인터넷뱅킹 등)에 의한 거래</li>
                <li>전화기(ARS, 스마트폰 등)에 의한 거래</li>
                <li>직불카드단말기에 의한 거래</li>
                <li>기타 전자적 장치에 의한 거래</li>
            </ol>

            <h3>제4조(전자금융거래계약의 체결 및 해지)</h3>
            <p>① 이용자가 전자금융거래를 하고자 하는 경우에는 사전에 대부업자와 별도의 전자금융거래계약을 체결하여야 한다.</p>
            <span class="indent">다만, 다음 각 호의 어느 하나에 해당하는 경우에는 그러하지 아니하다.</span>
            <ol>
                <li>단순조회(예금·대출잔액, 예금·대출 입·출금 내역 등)만을 이용하는 경우</li>
            </ol>
            <p>② 전자금융거래계약을 해지하고자 하는 경우 이용자 본인이 전자금융거래에 관한 개별약관에서 정한 바에 따라 서면 또는 해당 전자적 장치를 통하여 대부업자에 해지신청을 하여야 한다.</p>

            <h3>제5조(접근매체의 발급 및 등록)</h3>
            <p>① 대부업자가 접근매체를 발급할 때에는 이용자의 신청이 있는 경우에 한하여 본인임을 확인한 후 발급한다.</p>
            <p>② 제1항의 규정에도 불구하고 대부업자는 접근매체의 갱신 또는 대체발급 등을 위하여 이용자의 동의를 얻은 경우로서 다음 각 호의 어느 하나에 해당하는 경우에는 이용자의 신청이나 본인의 확인이 없는 때에도 발급할 수 있다.</p>
            <ol>
                <li>갱신 또는 대체발급 예정일 전 6개월 이내에 사용된 적이 없는 접근매체에 대하여 이용자로부터 갱신 또는 대체발급에 대한 서면(전자서명법 제2조 제3호의 규정에 의한 전자서명이 있는 전자문서를 포함한다) 동의를 얻은 경우</li>
                <li>갱신 또는 대체발급 예정일 전 6개월 이내에 사용된 적이 있는 접근매체의 경우, 그 예정일부터 1개월 이전에 이용자에게 발급 예정사실을 알린 후 20일 이내에 이용자로부터 이의제기가 없는 경우</li>
            </ol>
            <p>③ 이용자는 전자금융거래계약을 체결하고 거래 비밀번호 등을 전자적 장치를 통하여 직접 등록할 경우, 계약일을 포함하여 3영업일 이내에 등록하여야 한다.</p>

            <h3>제6조(접근매체의 관리)</h3>
            <p>이용자는 다른 법률에 특별한 규정이 없는 한, 전자금융거래에 필요한 접근매체를 제3자에게 대여·사용위임 또는 양도·담보 제공하거나 본인 이외의 제3자에게 누설하여서는 아니되며, 접근매체의 도용이나 위조 또는 변조를 방지하기 위한 관리에 충분한 주의를 기울여야 한다.</p>

            <h3>제6조의2(주민등록번호 비수집 및 생년월일 활용에 관한 특별규정)</h3>
            <p>① 대부업자는 「개인정보 보호법」 및 관련 지자체 조례 등 관계 법령에서 명시적으로 허용하는 경우를 제외하고는, 전자금융거래와 관련하여 이용자의 주민등록번호 등 고유식별정보를 수집·이용·제공 또는 보관하지 않는다.</p>
            <p>② 대부업자가 전자금융거래를 위하여 본인확인을 수행하는 경우, 다음 각 호와 같은 범위 내에서만 정보를 처리한다.</p>
            <ol>
                <li>공동(공인)인증서, 본인인증기관(PASS 등) 또는 증권사 등 제3의 기관이 자체적으로 처리하는 주민등록번호는 대부업자가 직접 열람·수집·보관하지 아니하며, 대부업자는 해당 기관으로부터 제공받은 암호화 또는 대체된 식별값(CI/DI), 생년월일(YYYYMMDD) 등 최소한의 정보를 이용하여 본인 여부를 확인한다.</li>
                <li>대부업자가 전자금융거래 화면에서 이용자의 생년월일(연·월·일) 또는 일부 마스킹된 식별값을 입력받는 경우, 이는 공동인증서·전자서명 또는 증권계좌 본인확인 일치 여부 확인을 위한 용도에 한하며, 이러한 정보는 해당 목적 달성 후 지체 없이 파기하고 별도로 저장·보관·제공하지 아니한다.</li>
            </ol>
            <p>③ 대부업자는 전자금융거래를 위하여 주민등록번호 수집이 불가한 구조 하에서, 다음 각 호의 방법으로 신용·거래 위험을 관리한다.</p>
            <ol>
                <li>이용자의 증권계좌 잔고·담보비율 등 자산상태 확인</li>
                <li>이용자가 직접 제출하는 신용정보 조회결과(예: CB사 직접조회 PDF 등)에 대한 열람(단, 보관이 필요한 경우에는 법령에서 허용하는 최소 범위 내에서만 보관하고, 보존기간 경과 후 즉시 파기한다)</li>
                <li>주식담보가치·담보비율 등을 기반으로 한 위험관리(반대매매, 추가납입 요구 등)</li>
            </ol>
            <p>④ 제1항 내지 제3항에도 불구하고, 금융위원회·금융감독원 등 관계기관의 명령 또는 법원의 영장 등 법령에 따른 요청이 있는 경우에는 그 범위 내에서 예외적으로 주민등록번호 등 고유식별정보를 처리할 수 있으며, 이 경우 대부업자는 관련 법령이 정한 절차와 기간에 따라 정보의 보호 및 파기에 관한 의무를 이행한다.</p>
            <p>⑤ 대부업자는 이용자가 주민등록번호 비수집 및 생년월일만 활용되는 구조에 관하여 문의하는 경우, 본 조의 내용 및 관련 개인정보 처리방침을 통해 그 취지 및 내용을 성실히 안내하여야 한다.</p>

            <h3>제7조(공동인증서 사용)</h3>
            <p>이용자는 이 약관의 적용대상인 전자금융거래를 이용하는 경우 원칙적으로 전자서명법에 따른 공동(공인)인증서를 사용하여야 한다.</p>
            <span class="indent">다만, 다음 각 호의 어느 하나에 해당하는 경우에는 그러하지 아니하다.</span>
            <ol>
                <li>본인 계좌에 대한 조회업무</li>
                <li>자동응답서비스, 현금자동지급기, 자동입출금기, 지급용단말기 등과 같이 공동(공인)인증서의 설치·운용이 불가능한 전자적 장치를 이용한 전자금융거래의 경우</li>
                <li>등록금, 원서접수비 등 본인 확인이 가능하고 입금계좌가 지정되어 있는 경우</li>
                <li>전자상거래에서 지급결제로써 신용카드에 의한 결제 또는 30만원 미만의 온라인 계좌이체</li>
                <li>전자화폐, 선불전자지급수단을 온라인상에서 사용하는 경우</li>
                <li>기타 감독당국이 인정하는 경우</li>
            </ol>

            <h3>제8조(이용시간)</h3>
            <p>① 이용자는 대부업자가 정한 시간 이내에서 전자금융거래를 이용할 수 있다.</p>
            <p>② 이용시간은 대부업자의 사정에 따라 달라질 수 있으며, 이용시간을 변경하고자 할 경우에는 1개월 전 영업점 및 대부업자 홈페이지 등 이용자가 접근하기 용이한 전자적 장치를 통하여 게시한다.</p>
            <span class="indent">다만, 시스템 장애복구, 긴급한 프로그램 보수, 외부요인 등 불가피한 경우에는 예외로 한다.</span>

            <h3>제9조(수수료)</h3>
            <p>① 대부업자는 전자금융 수수료를 이용자의 계좌에서 출금하거나 이용자로부터 직접 현금으로 받을 수 있으며, 수납방법은 개별약관에 따른다.</p>
            <p>② 수수료는 대부업자의 수수료율·계산방법에 따르며, 대부업자가 수수료율을 변경하고자 하는 때에는 그 내용을 영업점에 게시하거나 기타 이용자가 접근하기 용이한 전자적 장치를 통하여 변경일 1주일 전에 게시하여 1개월간 알린다.</p>

            <h3>제10조(이체한도)</h3>
            <p>이용자는 대부업자가 정한 지정방법에 따라 계좌이체 및 추심이체, 계좌송금에 대한 이체 최고한도를 설정하여야 한다.</p>

            <h3>제11조(거래의 성립)</h3>
            <p>이용자가 전자금융거래를 하고자 하는 경우에는 다음 각 호의 시기에 거래가 성립한다.</p>
            <ol>
                <li>계좌이체 및 추심이체의 경우: 이용자가 입력한 거래지시의 내용을 대부업자가 확인하고 출금자금(수수료를 포함한다)을 출금계좌 원장에 출금기록한 때</li>
                <li>현금출금의 경우: 이용자가 입력한 거래지시의 내용을 대부업자가 확인하고 출금자금을 출금계좌 원장에 출금기록한 때</li>
                <li>계좌송금의 경우: 대부업자가 이용자가 입력한 거래지시의 내용 및 입금자금을 모두 확인한 때</li>
                <li>예약에 의한 계좌이체 및 예약에 의한 추심이체의 경우: 대부업자가 이용자의 거래지시 내용을 확인한 때.</li>
            </ol>
            <span class="indent">다만, 이체시점에 자금이 출금계좌에 입금되어 있을 것을 조건으로 한다.</span>

            <h3>제12조(거래지시의 처리기준)</h3>
            <p>① 대부업자는 이용자의 거래지시에 포함된 계좌번호, 비밀번호, 이용자번호 등의 접근매체 정보를 신고된 것과 대조하여 그 일치여부를 확인한 후 거래지시를 처리한다.</p>
            <p>② 이용자의 거래지시와 관련하여 대부업자가 수신한 전자문서는 각 문서마다 독립된 것으로 본다.</p>
            <p>③ 제2항의 규정에도 불구하고 거래지시 전자문서가 동일한 내용으로 반복 수신된 경우, 대부업자는 전화 기타 이용자에게 즉시 통지할 수 있는 전자적 장치 등을 통하여 이용자의 진정한 거래지시 의사를 확인하는 절차를 거친 후 나머지 전자문서를 임의로 폐기할 수 있다.</p>
            <p>④ 대부업자는 이용자의 거래지시에 따라 출금계좌에서 자금을 인출할 때, 예금거래기본약관에 불구하고 통장이나 지급청구서 또는 수표 없이 인출한다.</p>
            <p>⑤ 대량계좌이체, 타행계좌이체 등과 같이 거래의 특성상 수취인의 명의를 확인할 수 없는 경우에는 수취인의 계좌번호를 기준으로 하여 거래를 처리한다.</p>
            <p>⑥ 타행계좌이체는 당일 중에 처리한다.</p>
            <span class="indent">다만, 당일 중 처리가 불가능한 경우에는 제19조 제4항에서 정한 바에 따라 처리한다.</span>
            <p>⑦ 예약에 의한 계좌이체 및 추심이체의 경우, 이체시점에 출금계좌의 자금이 이용자가 거래지시한 금액 이상일 때 처리한다.</p>
            <p>⑧ 제7항의 경우 이체지정일이 대부업자 휴무일로 정해질 때에는 다음 영업일에 거래를 처리한다.</p>

            <h3>제13조(추심이체의 출금 동의)</h3>
            <p>① 대부업자는 추심이체를 실행하기 위하여 다음 각 호에서 정하는 방식에 따라 미리 지급인으로부터 출금에 대한 동의를 얻어야 한다.</p>
            <ol>
                <li>대부업자가 지급인으로부터 서면(공동·공인 전자서명이 있는 전자문서를 포함한다)에 의하여 출금신청을 받는 방법</li>
                <li>수취인이 지급인으로부터 서면에 의한 출금의 동의를 받아 대부업자에게 전달(전자적인 방법에 의하여 출금동의의 내역을 전송하는 경우를 포함한다)하는 방법</li>
            </ol>
            <p>② 지급인은 수취인의 거래지시에 따라 지급인의 계좌원장에 출금기록이 끝나기 전까지 대부업자에 출금동의의 철회를 요청할 수 있다.</p>
            <p>③ 제2항에도 불구하고 대량으로 처리하는 거래 또는 예약에 의한 추심이체거래의 경우에는 지급인은 출금일 전 영업일까지 대부업자에 서면으로 출금동의의 철회를 요청할 수 있다.</p>

            <h3>제14조(거래의 제한)</h3>
            <p>① 다음 각 호의 어느 하나에 해당하는 경우에는 전자금융거래의 당해 지시에 따른 거래를 제한할 수 있다.</p>
            <ol>
                <li>전자금융거래의 처리시점에 출금계좌의 자금이 출금자금에 미달하는 때. 다만, 전자금융거래에 관한 개별약관에 따로 정한 경우에는 그에 따른다.</li>
                <li>입금 또는 출금계좌가 해지되었거나 거래중지계좌에 편입되었을 때</li>
                <li>이체일에 입금 또는 출금계좌의 잔액증명서가 발급되었을 때</li>
                <li>이용자가 설정한 이체한도를 초과하여 계좌이체 거래지시를 할 때</li>
                <li>입금계좌를 지정하여 계좌이체를 이용하기로 한 이용자가 지정하지 않은 계좌로 계좌이체 거래지시를 할 때</li>
                <li>법적 지급제한, 전자금융거래법 및 관련 법령 위반 등으로 거래 제공이 부적합하다고 대부업자가 인정했을 때</li>
            </ol>
            <p>② 다음 각 호의 어느 하나에 해당하는 경우에는 해당 전자적 장치를 통한 계좌이체의 전부를 제한할 수 있다.</p>
            <ol>
                <li>인증서 유효기간이 만료되었거나 인증서가 취소되었을 때</li>
                <li>컴퓨터 또는 전화기 등으로 전자금융거래를 이용하는 이용자가 12개월 이상 이용실적이 없을 때</li>
            </ol>
            <p>③ 대부업자가 제1항 및 제2항에 의해 전자금융거래를 제한한 경우에는 이용자의 거래지시가 있을 때 해당 전자적 장치를 통하여 그 사유를 알려야 한다.</p>
            <p>④ 제2항의 경우에 이용자는 대부업자가 정한 인증서 재발급·유효기간의 연장 또는 계속 사용의사 확인 등의 절차를 거쳐 전자금융거래를 이용할 수 있다.</p>

            <h3>제15조(지급의 효력발생시기)</h3>
            <p>① 계좌이체, 추심이체 및 계좌송금의 경우에는 수취인의 계좌 원장에 입금기록을 마친 때에 지급의 효력이 생긴다.</p>
            <p>② 현금출금의 경우에는 이용자가 현금을 수령한 때에 지급의 효력이 생긴다.</p>
            <p>③ 그 밖의 전자지급수단으로 지급하는 경우에는 거래지시된 금액의 정보가 수취인의 계좌가 개설되어 있는 대부업자 또는 다른 금융기관의 전자적 장치에 입력이 끝난 때에 지급의 효력이 생긴다.</p>

            <h3>제16조(거래지시의 철회)</h3>
            <p>① 이용자는 제15조에 의하여 거래가 완료되기 전까지, 전자금융거래 시 이용한 해당 전자적 장치 또는 대부업자가 정하는 절차에 따라 거래지시를 철회할 수 있다.</p>
            <p>② 대량으로 처리하는 거래 또는 예약에 의한 계좌이체 및 추심이체는 이체일 전 영업일까지 전자금융거래 시 이용한 해당 전자적 장치 또는 서면을 통하여 거래지시를 철회할 수 있다.</p>
            <p>③ 실시간 이체되는 거래 등 전자금융거래의 성질상 대부업자가 거래의 완료 여부를 즉시 확인할 수 없는 경우에는 제1항의 규정에도 불구하고 이용자의 거래지시 철회를 제한할 수 있다.</p>
            <p>④ 이용자의 요청에 따라 출금계좌를 해지할 때에는 해당 계좌에 등록된 예약에 의한 계좌이체 거래지시도 철회된다.</p>
            <p>⑤ 이용자의 사망, 한정치산 선고, 금치산 선고나 이용자 또는 대부업자의 해산·합병·파산은 그 자체로는 거래지시를 철회 또는 변경하는 것으로 되지 아니하며, 대부업자의 권한에도 영향을 미치지 아니한다.</p>

            <h3>제17조(거래내용의 확인)</h3>
            <p>① 대부업자는 제15조의 거래의 처리결과를 이용자가 전자금융거래에 이용한 해당 전자적 장치 또는 컴퓨터 등 대체 전자적 장치를 통하여 즉시 확인할 수 있도록 하여야 한다.</p>
            <span class="indent">다만, 타행계좌이체 및 예약에 의한 계좌이체의 경우에는 접수결과를 해당 전자적 장치를 통하여 이용자에게 즉시 알린다.</span>
            <p>② 제1항의 규정에도 불구하고 이용자가 요청하는 거래내용을 해당 전자적 장치 및 대체 전자적 장치로도 즉시 확인해 주는 것이 곤란할 경우, 대부업자는 해당 거래내용을 서면(전자문서를 제외한다) 형태로 출력하여 이용자에게 교부하여야 한다.</p>
            <p>③ 이용자는 거래지시와 제1항에 의한 처리결과가 일치하는지 여부를 확인하여야 한다.</p>

            <h3>제18조(오류의 정정)</h3>
            <p>① 이용자는 전자금융거래에 오류가 있음을 안 때에는 즉시 대부업자에 정정을 요구할 수 있으며, 이 경우 대부업자는 즉시 조사하여 이체자금의 이동경로를 확인하거나 출금을 제한하는 등 필요한 조치를 처리한 후, 정정요구를 받은 날부터 2주일 이내에 그 결과를 이용자에게 알려야 한다.</p>
            <p>② 대부업자는 스스로 전자금융거래에 오류가 있음을 안 때에는 이를 즉시 조사·처리한 후, 오류가 있음을 안 날부터 2주일 이내에 이용자에게 그 결과를 알려야 한다.</p>

            <h3>제19조(사고·장애 시의 처리)</h3>
            <p>① 이용자는 거래계좌에 관한 접근수단의 도난·분실·위조 또는 변조의 사실을 알았거나, 기타 거래절차상 비밀을 요하는 사항이 누설되었음을 알았을 때에는 지체 없이 이를 대부업자에 신고하여야 한다.</p>
            <p>② 제1항의 신고는 대부업자가 이를 접수한 후 그 효력이 생긴다.</p>
            <p>③ 제1항의 신고를 철회할 경우에는 이용자 본인이 대부업자에 서면으로 신청하여야 한다.</p>
            <p>④ 대부업자는 통신장애 및 기타의 사유로 인하여 거래지시된 전자금융거래가 처리 불가능할 경우 출금계좌로 입금 처리하고, 이용자의 신고된 연락처로 이를 통지하여야 한다.</p>
            <p>⑤ 대부업자는 이용자의 요청이 있을 때에는 사고 또는 장애의 사유를 지체 없이 조사하여 그 결과를 이용자에게 통지하여야 한다.</p>

            <h3>제20조(손실부담 및 면책)</h3>
            <p>① 대부업자는 접근매체의 위조나 변조로 발생한 사고, 계약체결 또는 거래지시의 전자적 전송이나 처리과정에서 발생한 사고로 인하여 이용자에게 손해가 발생한 경우에, 그 금액과 1년 만기 정기예금 이율로 계산한 경과이자를 보상한다.</p>
            <span class="indent">다만, 부정이체 결과로 당해 계좌에서 발생한 손실액이 1년 만기 정기예금 이율로 계산한 금액을 초과하는 경우에는 당해 손실액을 보상한다.</span>
            <p>② 제1항의 규정에도 불구하고 대부업자는 다음 각 호의 어느 하나에 해당하는 경우에는 이용자에게 손해가 생기더라도 책임을 지지 아니한다.</p>
            <ol>
                <li>천재지변, 전쟁, 테러 또는 대부업자의 귀책사유 없이 발생한 정전, 화재, 건물의 훼손 또는 테러 등 불가항력으로 인한 경우</li>
                <li>이용자가 접근매체를 제3자에게 대여하거나 사용을 위임하거나 양도 또는 담보 목적으로 제공한 경우</li>
                <li>제3자가 권한 없이 이용자의 접근매체를 이용하여 전자금융거래를 할 수 있음을 알았거나 쉽게 알 수 있었음에도 불구하고, 이용자가 자신의 접근매체를 누설 또는 노출하거나 방치한 경우</li>
                <li>법인(「중소기업기본법」 제2조 제2항에 의한 소기업을 제외한다)인 이용자에게 손해가 발생한 경우로서, 대부업자가 사고를 방지하기 위하여 보안절차를 수립하고 이를 철저히 준수하는 등 합리적으로 요구되는 충분한 주의의무를 다한 경우</li>
            </ol>
            <p>③ 이용자로부터 접근매체의 분실이나 도난의 통지를 받은 경우에는, 대부업자는 그 때부터 제3자가 그 접근매체를 사용함으로 인하여 이용자에게 발생한 손해를 보상한다.</p>

            <h3>제21조(거래기록·자료의 제공)</h3>
            <p>① 대부업자는 이용자의 요청이 있을 경우 「금융실명거래 및 비밀보장에 관한 법률」 등 다른 법률에 저촉되지 않는 범위 내에서, 대부업자가 보존·관리하고 있는 전자금융거래 관련 기록·자료를 이용자에게 제공하여야 한다.</p>
            <p>② 이용자가 제공 요청을 할 수 있는 거래기록·자료의 범위와 대상기간은 제22조 제1항 및 제2항에서 정한 기록 및 기간으로 한다.</p>
            <p>③ 이용자가 서면(전자문서를 제외한다) 형태의 거래기록·자료(이하 "거래명세서"라 한다)를 제공할 것을 대부업자에 요청하는 경우에는 본인이 서면으로 대부업자 영업점에 신청하여야 하며, 대부업자는 신청 가능 영업점의 주소(전자우편 주소를 포함한다) 및 전화번호 등을 인터넷 등을 통하여 이용자가 알 수 있도록 게시하여야 한다.</p>
            <p>④ 대부업자는 이용자로부터 제3항에 따른 거래명세서의 제공요청을 받은 경우 2주일 이내에 이용자에게 거래명세서를 교부하여야 하며, 이 경우 대부업자는 이용자에게 소정의 수수료를 받을 수 있다.</p>
            <p>⑤ 대부업자는 불가피한 사유로 인하여 거래기록·자료(거래명세서 포함)의 제공이 불가능한 경우에는 그 사유를 이용자에게 즉시 통보하여야 하며, 해당 사유가 소멸한 경우 다음 각 호에서 정한 기한 내에 이용자에게 확인 및 제공하여야 한다.</p>
            <ol>
                <li>전자적 장치를 통한 제공의 경우에는 즉시</li>
                <li>제3항에 따른 서면 제공 방식의 경우에는 2주일 이내에 거래명세서를 교부하여야 한다.</li>
            </ol>

            <h3>제22조(거래기록의 보존)</h3>
            <p>① 대부업자는 전자금융거래와 관련한 다음 각 호의 거래기록(조회거래는 제외한다)을 5년간 유지·보존하여야 한다.</p>
            <ol>
                <li>거래계좌의 명칭 또는 번호</li>
                <li>거래의 종류 및 금액, 거래상대방을 나타내는 정보</li>
                <li>거래일시, 전자적 장치의 종류 및 전자적 장치를 식별할 수 있는 정보</li>
                <li>대부업자가 수취한 전자금융 관련 수수료</li>
                <li>추심이체의 경우 지급인의 출금동의 내역</li>
                <li>전자금융거래 신청, 조건변경에 관한 내용</li>
                <li>해당 전자금융거래와 관련한 전자적 장치의 접속기록</li>
            </ol>
            <p>② 대부업자는 전자금융거래와 관련한 다음 각 호의 거래기록을 1년간 유지·보존하여야 한다.</p>
            <ol>
                <li>건당 거래금액이 1만원 이하인 소액거래에 관한 기록</li>
                <li>거래승인에 관한 기록</li>
                <li>오류정정 요구 및 처리기록</li>
            </ol>

            <h3>제23조(통지방법 및 효력)</h3>
            <p>① 대부업자는 제17조 제2항, 제19조 제4항 및 제5항 등 전자금융거래에서 발생하는 사항을 통지하는 경우, 이용자가 신고한 연락처로 전화, 서면 또는 기타 전자적 장치로 통지하여야 한다.</p>
            <p>② 대부업자가 서면으로 통지했을 때에는 천재지변 등 불가항력적인 경우 외에는 보통의 우송기간이 지났을 때 도달한 것으로 추정한다.</p>
            <p>③ 이용자가 제24조에 의한 변경신고를 게을리함에 따라 제2항에 의하여 발송한 서면통지가 이용자에게 연착하거나 도달하지 아니한 때에는, 보통의 우송기간이 경과한 때에 도달한 것으로 본다.</p>

            <h3>제24조(신고사항의 변경 등)</h3>
            <p>① 이용자가 계좌번호, 비밀번호, 이용자번호, 상호, 주소, 전화번호 등 대부업자에 신고한 사항을 변경하고자 할 경우에는 전자금융거래에 관한 개별약관에 정한 바에 따라 신고하여야 한다.</p>
            <p>② 신고사항의 변경은 대부업자가 제1항의 신고를 접수하고, 전산입력에 요구되는 합리적인 시간이 지난 후에 그 효력이 생긴다.</p>
            <p>③ 이용자는 제1항에서 정한 신고사항 이외의 각종 통지를 대부업자의 전자금융보조업자에게도 할 수 있다. 이 경우 전자금융보조업자에게 한 통지는 대부업자에 한 것으로 본다.</p>

            <h3>제25조(준수사항)</h3>
            <p>전자금융거래의 안전한 수행을 위하여 이용자는 대부업자가 정하는 바에 따라 다음 각 호의 사항을 준수하여야 한다.</p>
            <ol>
                <li>비밀번호 유출 및 해킹 등 전자적 침해를 방지하기 위하여 필요한 조치 및 관리 방법</li>
                <li>이용자 보호를 위하여 대부업자가 제공하는 절차와 방법</li>
                <li>기타 대부업자가 정하는 사항</li>
            </ol>

            <h3>제26조(거래내용 녹음)</h3>
            <p>대부업자는 거래의 정확성을 기하기 위하여, 직원과의 전화 통화에 의한 거래내용을 녹음할 수 있다.</p>
            <span class="indent">다만, 녹음된 내용은 해당 거래에 관한 분쟁이 발생할 경우의 증거자료로만 사용할 수 있으며, 이 경우 이용자는 대부업자에 녹음된 내용의 청취를 요구할 수 있다.</span>

            <h3>제27조(비밀보장의무)</h3>
            <p>① 대부업자는 법령에 정한 경우를 제외하고는, 전자금융거래 업무를 수행함에 있어서 알게 된 이용자의 인적사항 및 계좌, 접근매체 및 전자금융거래의 내용과 실적에 관한 정보 또는 자료를 이용자의 동의 없이는 다른 사람에게 제공하거나 누설하거나 업무 목적 외 사용을 하여서는 아니된다.</p>
            <p>② 대부업자의 관리소홀로 인한 이용자 관련 정보 도난 및 유출 시에는 대부업자가 책임을 진다.</p>

            <h3>제28조(약관의 교부 및 설명)</h3>
            <p>대부업자는 이용자의 요청이 있을 경우, 전자문서의 전송, 모사전송(FAX) 또는 우편의 방식으로 본 약관을 이용자에게 교부하고 약관의 내용을 설명한다.</p>

            <h3>제29조(약관의 변경)</h3>
            <p>① 대부업자가 이 약관을 변경하고자 할 때에는 변경예정일 직전 1개월간 대부업자의 영업점 및 인터넷 홈페이지 등에 변경내용을 게시하여 이용자에게 알려야 한다.</p>
            <span class="indent">다만, 법령의 개정이나 제도의 개선 등으로 긴급히 약관을 변경한 때에는 즉시 이를 게시하고 최소 1개월 이상 알린다.</span>
            <p>② 제1항의 약관변경 내용이 이용자에게 불리하게 변경된 경우, 제1항의 게시 외에 대부업자는 서면, 전자우편 등 이용자와 사전에 합의한 방법으로 변경 전 최소 1개월 전까지(제1항 단서의 경우 즉시) 개별 통지하여야 한다.</p>
            <span class="indent">다만, 기존 이용자에게 변경 전 내용이 그대로 적용되는 경우 또는 이용자가 변경내용에 대한 통지를 받지 아니하겠다는 의사를 명시적으로 표시한 경우에는 그러하지 아니하다.</span>
            <p>③ 대부업자는 제1항의 게시 또는 제2항의 통지를 할 경우 "이용자가 변경에 동의하지 아니한 경우 제1항의 게시 또는 제2항의 통지를 받은 날로부터 1개월 이내에 서면에 의한 이의를 제기하거나 계약을 해지할 수 있으며, 서면에 의한 이의 또는 계약해지의 의사표시를 하지 아니한 경우에는 변경에 동의한 것으로 본다"라는 취지의 내용을 함께 게시 또는 통지하여야 한다.</p>
            <p>④ 제1항의 게시 또는 제2항의 통지(제3항의 게시·통지내용 포함)를 받은 날로부터 1개월 이내에 이용자의 서면에 의한 이의 또는 계약해지의 의사표시가 대부업자에 도달하지 않은 때에는, 이용자가 변경에 동의한 것으로 본다.</p>
            <p>⑤ 대부업자는 약관을 영업점에 비치 또는 게시하여, 이용자가 요구할 경우 약관 사본을 교부하여야 한다.</p>

            <h3>제30조(약관적용의 우선순위)</h3>
            <p>① 대부업자와 이용자 사이에 개별적으로 합의한 사항이 이 약관에 정한 사항과 다를 때에는 그 합의사항을 이 약관에 우선하여 적용한다.</p>
            <p>② 전자금융거래에 관하여 이 약관에 정하지 않은 사항은 개별약관이 정하는 바에 따른다.</p>
            <p>③ 이 약관과 전자금융거래에 관한 개별약관에 정하지 않은 사항에 대하여는, 다른 약정이 없으면 「전자금융거래법」 등 관계 법령, 예금거래기본약관 및 여신거래기본약관을 적용한다.</p>

            <h3>제31조(이의제기 및 협조)</h3>
            <p>① 이용자는 전자금융거래의 처리에 관하여 이의가 있을 때에는 대부업자의 분쟁처리기구에 그 해결을 요구하거나, 금융감독원 금융분쟁조정위원회, 한국소비자원 소비자분쟁조정위원회 등을 통하여 분쟁조정을 신청할 수 있다.</p>
            <p>② 이용자가 대부업자의 영업점 또는 대부업자의 분쟁처리기구에 이의를 제기한 경우, 대부업자는 15일 이내에 이에 대한 조사 또는 처리결과를 이용자에게 알려야 한다.</p>
            <p>③ 대부업자는 손해배상 등 분쟁처리를 위한 분쟁처리책임자 및 담당자를 지정하고, 그 연락처를 관련 인터넷 홈페이지에 게시하여야 한다.</p>
            <p>④ 이용자는 제20조 제1항에 정한 사고발생으로 인한 손해배상 등 분쟁처리와 관련한 대부업자의 사전조사 및 관계당국의 수사 또는 조사 절차에 협조하여야 한다.</p>

            <h3>제32조(준거법 및 합의관할)</h3>
            <p>① 이 약관의 해석·적용에 관하여는 대한민국법을 적용한다.</p>
            <p>② 이 계약과 관련한 대부업자와 이용자 간의 소송에 대해서는 법이 정하는 관할법원과 아울러, 대부업자의 거래 영업점 소재지 지방법원을 관할법원으로 한다.</p>
        </div>
    `,

    // 7번: 여신거래 약정서
    "07": `
        <div class="terms-body">
            <h1>여신거래 약정서</h1>

            <div class="header-info">
                <p><strong>빌리언대부 주식회사 귀중</strong></p>
            </div>

            <div style="background: #fff9e6; padding: 15px; margin-bottom: 20px; border-left: 4px solid #ff9800;">
                <p style="margin: 0;"><strong>※ 안내사항</strong></p>
                <p style="margin: 5px 0 0 0;">본 여신거래약정서 중 제3조, 제4조, 제6조, 제10조, 제11조의 내용은 가계용인 경우에는 적용되지 않습니다.</p>
            </div>

            <h3>제1조 (거래조건)</h3>
            <p>① 거래조건은 아래와 같으며, 상세조건은 '참!좋은주식대출 계좌운용규칙'(첨부1 참조)의 내용과 같습니다.</p>

            <table>
                <colgroup>
                    <col style="width: 20%;">
                    <col style="width: 30%;">
                    <col style="width: 20%;">
                    <col style="width: 30%;">
                </colgroup>
                <tbody>
                    <tr>
                        <th>여신과목(여신종류)</th>
                        <td>일반자금대출</td>
                        <th>거래구분</th>
                        <td>한도거래</td>
                    </tr>
                    <tr>
                        <th>여신(한도)금액</th>
                        <td>금 <span class="terms-input-field" style="width: 150px;">원</span></td>
                        <th>계좌번호</th>
                        <td><span class="terms-input-field" style="width: 150px;">&nbsp;</span></td>
                    </tr>
                    <tr>
                        <th>여신개시일</th>
                        <td><span class="terms-input-field" style="width: 150px;">&nbsp;</span></td>
                        <th>여신기간만료일</th>
                        <td><span class="terms-input-field" style="width: 150px;">&nbsp;</span></td>
                    </tr>
                    <tr>
                        <th>이자율 등</th>
                        <td>연 <span class="terms-input-field inline-short">%</span><br>
                            (단, 이벤트 금리 적용 고객 대출일로부터 3개월 연 <span class="terms-input-field inline-short">%</span> 적용)
                        </td>
                        <th>지연배상금률<br>(빌리언대부 주식회사 여신거래기본약관 제3조 5항 적용)</th>
                        <td>1회차 연 23%<br>2회차 연 24%<br>3회차 이상 연 25%</td>
                    </tr>
                    <tr>
                        <th>여신(증액)금액</th>
                        <td>금 <span class="terms-input-field" style="width: 150px;">원</span></td>
                        <th>여신(한도)금액</th>
                        <td>금 <span class="terms-input-field" style="width: 150px;">원</span></td>
                    </tr>
                    <tr>
                        <th>계좌번호</th>
                        <td colspan="3"><span class="terms-input-field" style="width: 200px;">&nbsp;</span></td>
                    </tr>
                    <tr>
                        <th>여신개시일</th>
                        <td><span class="terms-input-field" style="width: 150px;">&nbsp;</span></td>
                        <th>여신기간만료일</th>
                        <td><span class="terms-input-field" style="width: 150px;">&nbsp;</span></td>
                    </tr>
                    <tr>
                        <th>이자율 등</th>
                        <td>연 <span class="terms-input-field inline-short">%</span><br>
                            (단, 이벤트 금리 적용 고객 대출일로부터 3개월 연 <span class="terms-input-field inline-short">%</span> 적용)
                        </td>
                        <th>지연배상금률<br>(빌리언대부 주식회사 여신거래기본약관 제3조 5항 적용)</th>
                        <td>1회차 연 23%<br>2회차 연 24%<br>3회차 이상 연 25%</td>
                    </tr>
                    <tr>
                        <th colspan="2">이자 및 지연배상금 계산방법</th>
                        <td colspan="2">1년을 365일로 보고 1일 단위로 계산합니다.</td>
                    </tr>
                    <tr>
                        <th>여신실행방법</th>
                        <td colspan="3">일정한 요건을 갖춘 본인의 청구가 있는 대로 실행합니다.</td>
                    </tr>
                    <tr>
                        <th>상환방법</th>
                        <td colspan="3">자유로이 상환하되, 1회전기간 만료일 또는 만료일 전에 일시 전액 상환하며, 여신기간 만료일에 전액 상환합니다.<br>
                            <strong>※ 빌리언대부 주식회사 영업시간 마감이후 자동화기기 또는 전자금융매체를 통한 계좌입금분은 당일 중 상환으로 처리 되지 않을 수 있음을 유의하시기 바랍니다.</strong>
                        </td>
                    </tr>
                    <tr>
                        <th>이자지급시기 및 방법</th>
                        <td colspan="3">빌리언대부 주식회사이 정한 매월 결산일에 지급합니다.<br>
                            <strong>※ 빌리언대부 주식회사 영업시간 마감이후 자동화기기 또는 전자금융매체를 통한 계좌입금분은 당일 중 상환으로 처리 되지 않을 수 있음을 유의하시기 바랍니다.</strong>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p>② 제1항의 거래방식에 있어서 한도거래라 함은 약정금액 및 거래기한 범위내에서 대출과 상환을 자유롭게 하기로 하는 것을, 개별거래라 함은 대출한 금액을 여신기간만료일에 일시 상환하거나 거래기한까지 분할하여 상환하기로 하는 것을 말합니다.</p>
            <p>③ 한도거래의 경우는 제1항의 여신기간만료일 이내에서 1회전기간을 정하여 운용할 수 있습니다.</p>

            <h3>제2조 (지연배상금)</h3>
            <p>① 이자·분할상환금·분할상환원리금을 그 기일에 지급하지 아니한 때에는 지급하여야 할 금액에 대하여, 곧 지연배상금을 지급하기로 합니다.</p>
            <p>② 여신기간 만료일에 채무를 이행하지 아니하거나, 빌리언대부 주식회사여신거래기본약관 제7조에 의하여 기한의 이익을 상실한 때(빌리언대부 주식회사여신거래기본약관 제9조에 의한 할인어음의 환매채무 발생 포함)에는, 그때부터 여신잔액에 대하여, 곧 지연배상금을 지급하기로 합니다.</p>
            <p>③ 계약금액내대출의 경우 상계전일까지는 지급하여야 할 이자에 대하여, 상계후에는 대출금잔액에 대하여, 곧 지연배상금을 지급하기로 합니다.</p>
            <p>④ 종합통장대출의 경우 이자원가 등으로 한도금액을 초과한 금액에 대하여 곧 지연배상금을 지급하기로 합니다.</p>

            <h3>제3조 (차용총액 확정 및 분할상환기일표 통지)</h3>
            <p>① 분할 실행하는 여신의 경우, 채무총액은 최종의 실행후에 확정되며, 확정방법은 분할 상환기일표 및 영수증 기타 증빙자료에 의합니다.</p>

            <h3>제4조 (감액·정지)</h3>
            <p>① 한도거래 및 분할 실행하는 여신의 경우, 국가경제·금융사정의 급격한 변동 또는 본인의 신용상태의 현저한 악화 등으로 여신거래에 중대한 지장을 초래한다고 판단될 때에는, 빌리언대부 주식회사은 통지에 의하여 제1조의 여신(한도)금액을 줄이거나, 거래기간에 불구하고 여신실행을 일시 정지 할 수 있습니다. 이 경우 본인은 감액으로 말미암은 한도초과 금액은 곧 갚기로 합니다.</p>
            <p>② 제1항에서 정한 사유가 해소되어 정상적 여신거래가 가능한 경우에는 빌리언대부 주식회사은 곧 감액·정지를 해소하기로 합니다.</p>

            <h3>제5조 (종합통장대출에 대한 약정)</h3>
            <p>① 이 약정에 의한 채무가 있는 때에는 종합통장기본계좌(이하 "모계좌"라 합니다)에 입금된 자금(증권류의 금액은 결제될때까지 이 자금에서 제외하며, 입금된 증권 등은 이 약정에 의한 채무의 담보로서 빌리언대부 주식회사에 양도한 것으로 합니다)은 자동적으로 대출금변제에 충당하기로 합니다.</p>
            <p>② 모계좌에 대해 그 잔액을 초과해서 지급청구하거나, 정기적 지급금 및 각종 요금 등의 자동납부 청구가 있는 때에는 모계좌를 통하여 대출금을 지급하거나 자동납부하는 것으로 합니다.</p>
            <p>③ 빌리언대부 주식회사은 이자의 원가 등을 위하여 필요한 경우에는 본인에게 사전통지를 하지 않더라도 제1조의 여신한도를 초과하여 지급할 수 있습니다. 이 경우 본인은 초과된 금액을 곧 갚기로 합니다.</p>
            <p>④ 이자 및 지연배상금은 모계좌에서 빼거나 제1조의 한도금액 초과여부에 불구하고 대출금에 더하기로 하며, 이 경우 한도를 초과한 금액은 곧 갚기로 합니다.</p>
            <p>⑤ 대출의 이자계산은 매일의 마감잔액을 기준으로 계산합니다. 다만, 당일중의 최고잔액이 당일중의 개시잔액 또는 마감잔액보다 클 경우에는 개시잔액과 마감잔액 중 큰 금액을 최고잔액에서 차감하여 그 차액을 마감잔액에 가산한 금액을 기준으로 하며, 연체좌에 대하여는 매일의 최고잔액을 기준으로 합니다.</p>
            <p>⑥ 종합통장대출의 경우 1회전기간 만료일 1개월 전까지 당사자 어느쪽에서도 다른 의사표시가 없는 경우에는 여신기간만료일 이내에서 자동적으로 직전의 1회전기간 만큼 거래기간이 연장되는 것으로 합니다.</p>

            <h3>제6조 (약정한도 미사용수수료)</h3>
            <p>한도거래의 경우 제1조의 여신(한도)금액 중 미사용금액에 대하여 따로 정한 약정이 있는 때에는, 약정으로 정한 기준에 의한 수수료를 지급하기로 합니다.</p>

            <h3>제7조 (인지세의 부담)</h3>
            <p>이 약정서 작성에 따른 인지세는 은행과 채무자(또는 설정자)가 각각 50% 씩 부담합니다.</p>

            <h3>제8조 (담보·보험)</h3>
            <p>본인은 빌리언대부 주식회사의 다른 의사표시가 없는 한, 이 약정에 의해 실행된 여신으로 건설 또는 설치된 시설물을 그것이 설치된 토지·건물 및 그 안의 기타 시설과 함께 빌리언대부 주식회사에 담보로 제공하기로 하며, 빌리언대부 주식회사이 요청하는 경우 빌리언대부 주식회사이 동의하는 종류와 금액의 보험에 가입하고 그 보험금 청구권에 빌리언대부 주식회사을 위하여 질권을 설정하기로 합니다.</p>

            <h3>제9조 (담보권 설정)</h3>
            <p>① 이 약정에 의한 채무를 담보하기 위하여 예금 등에 질권을 설정하고 빌리언대부 주식회사앞으로 그 증서(통장)의 인도를 마칩니다.</p>
            <p>② 제1항의 질권의 효력은 원금·수익권(이 계약 이후에 적립되는 금액을 포함합니다)과 이에 부수하는 이자·수익의 수익권, 특별장려금, 법정장려금 등에 미칩니다.</p>
            <p>③ 제1항의 질권은 그 목적인 예금등이 기한연장·개서·갱신·분할·병합·증액·감액 또는 이자원가된 경우에도 그 위에 질권의 효력이 미침을 승인합니다.</p>
            <p>④ 빌리언대부 주식회사은 제1항에 의한 질권을 행사하지 아니하고 빌리언대부 주식회사여신거래기본약관의 정하는 바에 따라 빌리언대부 주식회사의 채권과 아래 표시의 예금등을 상계 또는 대리환급변제충당을 할 수 있습니다.</p>

            <h3>제10조 (상환자력 유지의무 등)</h3>
            <p>① 본인은 이 거래약정으로 말미암은 채무의 상환자력유지를 위하여 적절한 재무비율을 유지하기로 합니다. 그 밖에 재무구조개선약정 등이 따로 있는 경우에는 이 거래 약정의 끝부분에 이를 붙이고 그 내용은 이 거래 약정의 일부로 봅니다.</p>
            <p>② 본인이 다음 각 호의 행위를 하고자 할 때에는 사전에 빌리언대부 주식회사과 협의하기로 합니다.</p>
            <ol>
                <li>합병, 영업양수도 및 중요한 재산의 매각·임대</li>
                <li>이 거래약정에 따른 자금용도 외의 고정자산에 대한 투자</li>
                <li>타인의 채무를 위한 보증</li>
                <li>신규사업 진출 또는 해외투자</li>
                <li>기업구조 개선 작업(Work Out) 또는 사적화의 신청 등 경영상 중대한 변화가 생길 우려가 있는 경우</li>
            </ol>
            <p>③ 본인은 빌리언대부 주식회사이 이 거래약정의 사후관리상 그 필요성이 현저하다고 인정하여 다음 각 호의 행위를 청구하는 경우 그에 응하기로 합니다.</p>
            <ol>
                <li>보유 부동산 및 유가증권 매각</li>
                <li>지배주주의 출자</li>
                <li>유상증자 또는 기업공개</li>
            </ol>
            <p>④ 제1항 내지 제3항의 규정은 본인과 빌리언대부 주식회사간에 각 항별로 별도의 특약이 있는 경우에만 적용합니다.</p>

            <h3>제11조 (자료의 제출 등)</h3>
            <p>본인은 빌리언대부 주식회사이 빌리언대부 주식회사여신거래기본약관 제17조 및 제19조에 근거하여 매 시기별로 요청하는 다음 각 호의 자료 기타 여신의 사후관리를 위하여 필요한 자료를 빌리언대부 주식회사의 요청이 있는 대로 제출하기로 합니다.</p>
            <ol>
                <li>매분기: 부가가치세 과세표준 증명원, 합계잔액시산표, 부채현황표, 판매처 및 제품별 매출예상표 등</li>
                <li>매반기: 반기결산보고서, 부가가치세 과세표준증명원, 합계잔액시산표, 부채현황표, 판매처 및 제품별 매출예상표 등</li>
                <li>매년: 공인회계사 감사보고서(결산재무제표), 연결재무제표, 법인등기부등본, 사업자등록증, 주주명부, 정관, 근로소득세징수액집계표, 사업계획서, 추정재무제표(3개년), 주요거래처현황, 각종 인허가 및 기술인증관련 서류사본(KS, ISO, 특허권 등), 노사분규확인서, 기타 제품설명서, 동업계 참고자료 등</li>
                <li>수시: 합계잔액시산표, 부채현황표, 자금용도확인서류 등</li>
            </ol>

            <br><hr><br>

            <div style="background: #f5f5f5; padding: 15px; margin: 20px 0; border-left: 4px solid #1976d2;">
                <p style="margin: 0; font-weight: bold;">인지세 정보</p>
                <p style="margin: 5px 0 0 0;">대한민국정부 / 인지세 0원 / 분당세무서장 / 후납승인2011년02호</p>
            </div>

            <p><strong>본인은 여신거래기본약관, 핵심설명서 및 이 약정서 사본을 확실히 수령(주식매입자금대출 전용 홈페이지 내에서 본인이 동의한 약관 및 약정서 내용을 출력함)하고, 주요내용에 대하여 충분한 설명을 듣고 이해하였음.</strong></p>

            <div style="margin-top: 30px;">
                <p><span class="terms-input-field date-field">20&nbsp;&nbsp;&nbsp;&nbsp;년&nbsp;&nbsp;&nbsp;&nbsp;월&nbsp;&nbsp;&nbsp;&nbsp;일</span></p>
                <br>
                <p>본인: <span class="terms-input-field" style="width: 200px;">&nbsp;</span> (서명 또는 전자서명)</p>
                <p>주소: <span class="terms-input-field" style="width: 400px;">&nbsp;</span></p>
                <br>
                <p>본인: <span class="terms-input-field" style="width: 200px;">&nbsp;</span> (서명 또는 전자서명)</p>
                <p>주소: <span class="terms-input-field" style="width: 400px;">&nbsp;</span></p>
            </div>
        </div>
    `,

    // 8번: 여신(기한연장) 신청서
    "08": `
        <div class="terms-body">
            <h1>여신(□기한연장, □조건변경) 신청서</h1>

            <div class="header-info">
                <p><strong>빌리언대부 주식회사 귀중</strong></p>
            </div>

            <p>본인은 위 빌리언대부 주식회사으로부터 차입한 아래 여신에 대해 거래조건을 다음과 같이 변경하고자 신청합니다.</p>

            <h3>1. 조건변경하고자 하는 여신내용</h3>

            <table style="font-size: 11px; table-layout: fixed; width: 100%;">
                <colgroup>
                    <col style="width: 12%;">
                    <col style="width: 13%;">
                    <col style="width: 13%;">
                    <col style="width: 17%;">
                    <col style="width: 12%;">
                    <col style="width: 13%;">
                    <col style="width: 20%;">
                </colgroup>
                <thead>
                    <tr>
                        <th style="padding: 6px 2px; line-height: 1.3;">차입<br/>일자</th>
                        <th style="padding: 6px 2px; line-height: 1.3;">여신<br/>과목</th>
                        <th style="padding: 6px 2px; line-height: 1.3;">여신<br/>한도</th>
                        <th style="padding: 6px 2px; line-height: 1.3;">약정기일</th>
                        <th style="padding: 6px 2px; line-height: 1.3;">적용<br/>금리</th>
                        <th style="padding: 6px 2px; line-height: 1.3;">연장<br/>수수료</th>
                        <th style="padding: 6px 2px; line-height: 1.3;">비고<br/>(계좌번호)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style="text-align: center; padding: 6px 2px; font-size: 10px; line-height: 1.3;"><span class="terms-input-field" style="width: 95%; display: inline-block;">&nbsp;</span></td>
                        <td style="text-align: center; padding: 6px 2px; line-height: 1.3;">일반<br/>자금<br/>대출</td>
                        <td style="text-align: center; padding: 6px 2px; font-size: 10px; line-height: 1.3;"><span class="terms-input-field" style="width: 85%; display: inline-block;">원</span></td>
                        <td style="text-align: center; padding: 6px 2px; line-height: 1.3;">만기일<br/>로부터<br/>개월후</td>
                        <td style="text-align: center; padding: 6px 2px; line-height: 1.3;"><span class="terms-input-field inline-short">%</span></td>
                        <td style="text-align: center; padding: 6px 2px; line-height: 1.3;"><span class="terms-input-field inline-short">%</span></td>
                        <td style="text-align: center; padding: 6px 2px; font-size: 10px; word-break: break-all; line-height: 1.3;"><span class="terms-input-field" style="width: 95%; display: inline-block;">&nbsp;</span></td>
                    </tr>
                </tbody>
            </table>

            <h3>2. 조건변경(보증인교체, 면제포함), 기한연장신청 내용</h3>

            <table>
                <colgroup>
                    <col style="width: 25%;">
                    <col style="width: 37.5%;">
                    <col style="width: 37.5%;">
                </colgroup>
                <thead>
                    <tr>
                        <th>구분</th>
                        <th>변경 전</th>
                        <th>변경 후</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th>만기일</th>
                        <td style="text-align: center;"><span class="terms-input-field" style="width: 80%; display: inline-block;">&nbsp;</span></td>
                        <td style="text-align: center;"><span class="terms-input-field" style="width: 80%; display: inline-block;">&nbsp;</span></td>
                    </tr>
                    <tr>
                        <th>대출이자율</th>
                        <td style="text-align: center;"><span class="terms-input-field inline-short">%</span></td>
                        <td style="text-align: center;"><span class="terms-input-field inline-short">%</span></td>
                    </tr>
                    <tr>
                        <td colspan="3" style="text-align: center;"><strong>변경사유: 만기연장</strong></td>
                    </tr>
                </tbody>
            </table>

            <br>

            <p>본인: <span class="terms-input-field" style="width: 200px;">&nbsp;</span><br>
            주소: <span class="terms-input-field" style="width: 400px;">&nbsp;</span></p>

            <h3>※ 주1)</h3>
            <ol>
                <li>기한연장으로 인하여 적용금리가 변경되는 경우에는 금리변경내역도 조건변경내용에 포함할 것.</li>
                <li>조건변경내용이 보증인 교체(면제)인 경우 신/구 연대보증인이 모두 서명(날인)하되, 연대보증인 앞에"신" 또는 "구"를 표기하여 신/구 연대보증인을 구분할 수 있도록 하고 면제인 경우에는 변경후 란에"면제"라 기재할 것.</li>
                <li>보증인 교체(면제)인 경우에는 조건변경하고자 하는 차용내용의 비고란에 보증종류, 보증한도 등을 기재하며, 보증인 추가인 경우에는 변경사유란에 "보증인 추가"라고 기재할 것.</li>
                <li>한도거래의 조건변경은 추가약정서(한도거래조건변경용)로 운용할 것.</li>
            </ol>

            <br><hr><br>

            <div style="margin-top: 30px;">
                <p style="text-align: right;"><span class="terms-input-field date-field">20&nbsp;&nbsp;&nbsp;&nbsp;년&nbsp;&nbsp;&nbsp;&nbsp;월&nbsp;&nbsp;&nbsp;&nbsp;일</span></p>
                <br>
                <p style="text-align: right;">신청인: <span class="terms-input-field" style="width: 200px;">&nbsp;</span> <strong>서명 또는 (인)</strong></p>
                <p style="text-align: right;">주민번호: <span class="terms-input-field" style="width: 250px;">&nbsp;</span></p>
                <br><br>
                <div style="text-align: right;"></div>
            </div>
        </div>
    `
};

// 약관 모달 표시
function showAgreement(num) {
    const modal = document.getElementById('agreementModal');
    const title = document.getElementById('agreementTitle');
    const content = document.getElementById('agreementContent');
    
    const key = String(num).padStart(2, '0');
    
    if (TERMS_TITLES[key] && TERMS_CONTENT[key]) {
        title.textContent = TERMS_TITLES[key];
        content.innerHTML = TERMS_CONTENT[key];
        modal.style.display = 'block';
        content.scrollTop = 0;
        modal.scrollTop = 0;
        
        // 프린트 버튼 표시 여부 (7번, 8번만)
        const printBtn = document.getElementById('printAgreementBtn');
        if (printBtn) {
            if (key === '07' || key === '08') {
                printBtn.style.display = 'inline-block';
            } else {
                printBtn.style.display = 'none';
            }
        }
    } else {
        alert('약관 내용을 불러올 수 없습니다.');
    }
}

// 약관 프린트
function printAgreement() {
    const content = document.getElementById('agreementContent');
    const title = document.getElementById('agreementTitle');
    
    if (!content || !title) return;
    
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="UTF-8">
            <title>${title.textContent}</title>
            <style>
                @media print {
                    @page { margin: 2cm; }
                }
                body {
                    font-family: 'Malgun Gothic', sans-serif;
                    line-height: 1.6;
                    color: #333;
                    padding: 20px;
                }
                h1 {
                    text-align: center;
                    font-size: 24px;
                    margin-bottom: 30px;
                }
                h3 {
                    font-size: 16px;
                    margin-top: 20px;
                    margin-bottom: 10px;
                }
                table {
                    width: 100%;
                    border-collapse: collapse;
                    margin: 15px 0;
                    font-size: 12px;
                }
                table th, table td {
                    border: 1px solid #333;
                    padding: 8px;
                    text-align: left;
                }
                table th {
                    background-color: #f5f5f5;
                    font-weight: bold;
                }
                .terms-input-field {
                    display: inline-block;
                    border-bottom: 1px solid #333;
                    min-height: 1em;
                }
                p, li {
                    font-size: 12px;
                }
                ol, ul {
                    padding-left: 20px;
                }
            </style>
        </head>
        <body>
            ${content.innerHTML}
        </body>
        </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
        printWindow.print();
        printWindow.close();
    }, 250);
}

// 모달 닫기
function closeAgreementModal() {
    const modal = document.getElementById('agreementModal');
    if (modal) {
        modal.style.display = 'none';
    }
}

// 전역 스코프에 명시적으로 노출
window.TERMS_TITLES = TERMS_TITLES;
window.TERMS_CONTENT = TERMS_CONTENT;
window.showAgreement = showAgreement;
window.closeAgreementModal = closeAgreementModal;
window.printAgreement = printAgreement;

// 모달 외부 클릭 시 닫기
window.addEventListener('click', function(event) {
    const modal = document.getElementById('agreementModal');
    if (event.target === modal) {
        closeAgreementModal();
    }
});

// 페이지 로드 시 체크박스 기능 초기화
document.addEventListener('DOMContentLoaded', () => {
    const allAgreeCheck = document.getElementById('allAgreeCheck');
    
    // 약관 동의 페이지가 아니면 실행 안 함
    if (!allAgreeCheck) {
        return; // 약관 페이지가 아니면 종료
    }
    
    const individualAgreements = document.querySelectorAll('input[name="agree"]');
    const btnNext = document.getElementById('btnNext');
    const totalAgreements = individualAgreements.length;

    function checkAllAgreed() {
        const checkedCount = document.querySelectorAll('input[name="agree"]:checked').length;
        return checkedCount === totalAgreements;
    }

    function syncAllAgreeCheckbox() {
        const checkedCount = document.querySelectorAll('input[name="agree"]:checked').length;
        allAgreeCheck.checked = (checkedCount === totalAgreements);
    }

    allAgreeCheck.addEventListener('change', (e) => {
        individualAgreements.forEach(checkbox => {
            checkbox.checked = e.target.checked;
        });
    });

    individualAgreements.forEach(checkbox => {
        checkbox.addEventListener('change', () => {
            syncAllAgreeCheckbox();
        });
    });

    btnNext.addEventListener('click', () => {
        if (checkAllAgreed()) {
            window.location.href = 'so_c2034.html';
        } else {
            alert('모든 필수 약관에 동의해야 합니다.');
        }
    });

    // Initialize
    syncAllAgreeCheckbox();
});
